/** 
 * 
 * PER FASCE DI ETA' cercare      {1>2 ? (
*/

import React, { useState, useRef,useEffect, useContext,useCallback } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import RouterContext from "../../context/RouterContext";
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import InfoIcon from '@mui/icons-material/Info';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import "../../App.css";
import axios from 'axios';
import {Box} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import {ThreeDots} from 'react-loader-spinner';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import {updateSeduta} from "./Utils";
import {properties} from "../../utils/properties";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import IconButton from '@mui/material/IconButton';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '@mui/material/Modal';
import PreviewIcon from '@mui/icons-material/Preview';
import AddIcon from '@mui/icons-material/Add';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { encode } from 'js-base64';
import AmbitiMultiSelect from "../../utils/AmbitiMultiSelect";
import AddchartIcon from '@mui/icons-material/Addchart';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
//import { Editor } from '@tinymce/tinymce-react';
import SweetAlert from "react-bootstrap-sweetalert";
import {Stack} from "@mui/material";
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import {
    Select,
    MenuItem,
    Paper
  } from "@mui/material";
import { Editor } from '@tinymce/tinymce-react';
//import { ConstructionOutlined, ElectricScooterRounded, FolderZip } from "@mui/icons-material";
import LockPersonIcon from '@mui/icons-material/LockPerson';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import HttpsIcon from '@mui/icons-material/Https';
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import DoneIcon from '@mui/icons-material/Done';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import EventIcon from "@mui/icons-material/Event";
import SchedaProgetto from "./SchedaProgetto";
import html2canvas from 'html2canvas';
import CircularProgress from "@mui/material/CircularProgress";
import { UndoOutlined } from "@mui/icons-material";


export default function Card() {

    const ASSETS = "/assets";    
    const [elementiStrategia, setElementiStrategia] = useState([]);
    let {dataSeduta, faseSeduta, idScheda } = useParams();    
    const [alert, setAlert] = React.useState(null);    
    const [loading, setLoading]= React.useState(true);  
    const [score, setScore] = useState([]);
    const [homeData, setHomeData] = useState([]);    
    const [dataSlide, setDataSlide] = useState([]);    
    const [relazioneData, setRelazioneData] = useState([]);    
    const navigate = useNavigate();
    const { pageRouter, setPageRouter } = useContext(RouterContext);         
    
    const [openSlide, setOpenSlide] = useState(false);
    const [open, setOpen] = useState(false);
    const [openedLabel, setOpenedLabel]= useState(null);
    const [openII, setOpenII] = useState(false);
    const [editorContent, setEditorContent] = useState('');
    const [itemContent, setItemContent] = useState('');
    const [commentContent, setCommentContent] = useState('');

    const [formatModel, setFormatModel] = useState([]);
    const [suggestion, setSuggestion] = useState(null);
    //
    const [praticaBloccataOriginalField, setPraticaBloccataOriginalField] = useState('');
    //const [praticaUltimaModificaOriginalField, setPraticaUltimaModificaOriginalField] = useState('');
    //const [praticaModificataDaOriginalField, setPraticaModificataDaOriginalField] = useState('');
    const [praticaBloccata, setPraticaBloccata] = useState(false);
    const [praticaUltimaModifica, setPraticaUltimaModifica] = useState('');
    const [praticaModificataDa, setPraticaModificataDa] = useState('');
    
    const [sedutePrecedenti, setSedutePrecedenti] = useState('');    

    const hiddenFileUpload2 = React.useRef(null);

    const schedaRef = useRef(null);  
    const [loadingSlide, setLoadingSlide] = useState(false);
    const [errorSlide,   setErrorSlide]   = useState(null);
     
    const menuLabels={
        0:'Modello Libero',
        1:'Delibera di stanziamento',
        2:'Delibera di accantonamento',
        3:'Delibera di approvazione di bandi/linee guida',
        4:'Delibera di approvazione esiti di bandi/linee guida',
        5:"Delibera di approvazione di convenzioni/protocolli d'intesa/ accordi quadro",
        6:'Modifiche statutarie di Enti strumentali e partecipati',
        7:'Informativa per aggiornamento su progetti',
        8:'Richiesta di parere',
        9:'Delibera di ridestinazione',
        10:'Delibera per progetti/azioni pluriennali',        
    }
    const [selectOpen, setSelectOpen] = useState(false);

    const strategiaMap = {
        //PERSONE
        1: {numero: "A",
            attiva: true,
            colore: "#F0B323",
            testo: [
                { t: "Sostegno allo sviluppo di " },
                { t: "nuovi modelli e iniziative di inclusione e benessere abitativo ", accent: true, bold: true },
                { t: "e di sostegno all’" },
                { t: "affordable housing ", italic: true },
                { t: "rivolti in particolare a persone in condizioni di fragilità (es. giovani, persone anziane, senza fissa dimora, con background migratorio), in termini di offerta, strumenti, tipologie, modalità di utilizzo e forme di proprietà degli spazi abitativi." },              
            ]
        },
        2: {numero: "B",
            attiva: true,
            colore: "#F0B323",
            testo: [
                { t: "Promozione di iniziative di " },
                { t: "rigenerazione urbana ", accent: true, bold: true },
                { t: "che integrino le dimensioni oggi fondamentali di una città inclusiva, accogliente ed efficiente." },                
            ]
        },
        3: {numero: "C",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Studi e azioni sperimentali che sviluppino strumenti, pratiche e processi di " },
              { t: "pianificazione e trasformazione dei territori ", accent: true, bold: true },
              { t: "capaci di coniugare sviluppo locale e coesione sociale, anche attraverso tecnologie innovative." },              
            ]
        },
        4: {numero: "A",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Sostenere iniziative volte ad aiutare le nuove generazioni ad acquisire le competenze necessarie a " },
              { t: "progettare il proprio percorso di vita ", accent: true, bold: true },
              { t: "e ad affrontare i cambiamenti e le transizioni che investiranno il mercato del lavoro, valorizzando e sostenendo i loro " },
              { t: "talenti", accent: true, bold: true },
              { t: ", promuovendo una cultura del lavoro positiva e la " },
              { t: "consapevolezza dei diritti", accent: true, bold: true },
              { t: ", in particolare quelli relativi alle condizioni di sicurezza sul luogo del lavoro, e tenendo in considerazione la condizione di incertezza, ansia e paura del fallimento che spesso caratterizza la loro visione di futuro.", accent: true, bold: true },              
            ]
        },
        5: {numero: "B",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Sperimentare interventi integrati utili al raggiungimento della maggior " },
              { t: "autonomia ", accent: true, bold: true },
              { t: "possibile di persone tra cui quelle con disabilità, background migratorio e inserite in percorsi di esecuzione penale, per " },
              { t: "affrontare " , accent: true, bold: true },
              { t: "in modo personalizzato e innovativo le " },
              { t: "diverse forme di povertà e disagio " , accent: true, bold: true },
              { t: "(lavoro povero, disoccupazione, basso livello di istruzione e formazione, precarietà abitativa, debolezza delle reti personali e sociali, salute e benessere delle persone)." },                            
            ]
        },
        6: {numero: "C",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Promuovere " },
              { t: "alleanze strategiche ", accent: true, bold: true },
              { t: "tra attori pubblici, privato sociale e imprese " },
              { t: "for profit", italic: true },
              { t: ", che contribuiscano all’individuazione e costruzione di risposte innovative e di sistema, capaci di aumentare la " },
              { t: "partecipazione equa al mercato del lavoro", accent: true, bold: true },
              { t: ", in particolare delle donne. In questo impegno, favorire una diversa narrazione rispetto agli stereotipi di genere, e perseguire la sperimentazione di soluzioni di conciliazione vita-lavoro, flessibilità di nuove forme di welfare e organizzazione del lavoro."},              
            ]
        },

        7: {numero: "A",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Sostenere progetti che mirino al benessere delle persone " },
              { t: "minorenni ", accent: true, bold: true },
              { t: "e contribuire al rafforzamento delle loro " },
              { t: "competenze cognitive, culturali, digitali, sociali ed emotive ", accent: true, bold: true },
              { t: ", perché tutte e tutti realizzino liberamente se stessi e le proprie aspirazioni, partecipando attivamente, con rispetto, consapevolezza e spirito critico, ai cambiamenti per un futuro più sostenibile ed equo, diventando adulti e cittadini responsabili."},              
            ]
        },
        8: {numero: "B",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Sostenere, con approcci innovativi, l’" },
              { t: "empowerment", accent: true, bold: true, italic: true },
              { t: ", l’aggiornamento continuo, la partecipazione degli " },
              { t: "adulti di riferimento della comunità educante ", accent: true, bold: true },
              { t: "(famiglie, docenti, educatori, operatori sociali, culturali, sportivi e sanitari, soggetti inediti, ecc.), che hanno responsabilità di cura ed educazione." },              
            ]
        },
        9: {numero: "C",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Ridurre ", accent: true, bold: true },
              { t: "le diseguaglianze e la " },
              { t: "povertà educativa minorile", accent: true, bold: true },
              { t: ", grazie a ecosistemi educativi competenti, capaci di operare secondo una logica collaborativa, multidimensionale, multi-attore, intersezionale e personalizzata, fondata su un uso consapevole dei dati e delle tecnologie, orientati alla " },
              { t: "qualità educativa delle opportunità ", accent: true, bold: true },
              { t: "(formali, non formali e informali), all’innovazione di metodi, processi e contesti in un’ottica inclusiva, anche attraverso le competenze del Gruppo Fondazione Compagnia di San Paolo." },              
            ]
        },
        10: {numero: "D",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Promuovere la " },
              { t: "cultura dei diritti dell’infanzia ", accent: true, bold: true },
              { t: "e dell’adolescenza, attraverso la sensibilizzazione, la capitalizzazione delle pratiche per le policy, nonché azioni di "},              
              { t: "Advocacy", italic: true },
              { t: ", anche riguardanti le professioni educative." },              
            ]
        },
        11: {   numero: "A",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Promuovere la salute e il benessere mentale delle giovani generazioni, attraverso il protagonismo delle persone giovani nella costruzione di risposte efficaci e nel lavoro di " },
              { t: "Advocacy ", italic: true },
              { t: "per una " },
              { t: "nuova cultura della salute e del benessere mentale", accent: true, bold: true },
              { t: ", che prenda in considerazione le cause profonde di quella che è una crisi a livello globale." },                            
            ]
        },
        12: {   numero: "B",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Sostenere le comunità locali ad affrontare la " },
              { t: "transizione demografica ", accent: true, bold: true },
              { t: "e le trasformazioni del tessuto sociale, a partire dalla promozione dell’invecchiamento in salute, facilitando un " },
              { t: "ruolo attivo delle persone anziane ", accent: true, bold: true },
              { t: "all’interno della comunità, contrastando la povertà relazionale, sfruttando le opportunità offerte dalla transizione tecnologica e digitale e promuovendo pratiche di prossimità." },          
            ]
        },
        13: {   numero: "C",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Promuovere la qualità della vita e il benessere delle persone che svolgono lavoro di cura sia professionale sia informale, sviluppando un approccio attento alla prospettiva e alle diseguaglianze di genere, nella cornice della promozione di un’ampia riflessione culturale sulle questioni della " },
              { t: "politica", accent: true, bold: true },
              { t: ", dell’"},
              { t: "economia", accent: true, bold: true },
              { t: " e dell’"},
              { t: "etica della cura", accent: true, bold: true },
              { t: "."},           
            ]
        },

        14: {   numero: "D",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Sostenere sistemi di collaborazione territoriale per l’approvvigionamento e la distribuzione di beni alimentari, nella prospettiva di politiche locali del cibo, in grado di coniugare tematiche quali " },
              { t: "contrasto alla povertà alimentare", accent: true, bold: true },              
              { t: ", accesso a cibo sano in modo continuativo e sostenibile, impatto ambientale/mitigazione e adattamento al cambiamento climatico." },                                          
            ]
        },
        15: {   numero: "E",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Rafforzare il ruolo catalitico delle Fondazioni di comunità e consolidare ed estendere partnership locali strategiche con i diversi " },
              { t: "stakeholder ", italic: true },
              { t: "del territorio, per avviare progettualità innovative che promuovano sviluppo locale e forniscano "},
              { t: "risposte integrate ", accent: true, bold: true },              
              { t: "e multilivello per " },
              { t: "persone con disabilità ", accent: true, bold: true },              
              { t: "e in condizioni di " },
              { t: "vulnerabilità ed esclusione sociale", accent: true, bold: true },              
              { t: ", tra cui persone detenute e persone senza dimora." },              
            ]
        },
        16: {   numero: "A",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Favorire " },
              { t: "empowerment ", italic: true },
              { t: "e autonomia dei "},
              { t: "giovani ", accent: true, bold: true },
              { t: "affinché siano " },
              { t: "protagonisti riconosciuti e valorizzati ", accent: true, bold: true },
              { t: "all’interno della società. Costruire, anche coinvolgendo individui a rischio o in situazione di difficoltà, processi condivisi con i territori al fine di rendere i giovani attori di cambiamento." },
            ]
        },
        17: {   numero: "B",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Sostenere alleanze territoriali interistituzionali che costruiscano sistemi di risposta integrati e multidimensionali, programmazioni locali partecipate e narrazioni orientate alla coesione sociale per favorire il " },
              { t: "pieno accesso a opportunità e diritti", accent: true, bold: true },
              { t: ", valorizzare il potenziale locale e "},
              { t: "contrastare ", accent: true, bold: true },
              { t: "forme di " },
              { t: "esclusione ", accent: true, bold: true },
              { t: "di persone con background migratorio, favorendo il loro protagonismo."},              
            ]
        },
        18: {   numero: "C",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Sostenere i territori nella loro capacità di offrire " },
              { t: "sostegno, orientamento e assistenza alle persone vittime ", accent: true, bold: true },
              { t: "di reato (prevalentemente reati contro la persona) e " },
              { t: "di violenza ", accent: true, bold: true },              
              { t: ", e in particolare alle donne vittime di violenza di genere, contribuendo al supporto e alla sperimentazione di interventi in materia di contrasto e " },
              { t: "prevenzione ", accent: true, bold: true },              
              { t: "del fenomeno." },              
            ]
        },
        19: {   numero: "D",
            attiva: true,
            colore: "#F0B323",
            testo: [
              { t: "Promuovere iniziative di partenariato territoriale tra aree diverse del mondo, in collaborazione con attori specializzati dei nostri territori e con altre fondazioni, sostenendo processi di rafforzamento di competenze e conoscenze volte alla " },
              { t: "promozione di uno sviluppo sostenibile ", accent: true, bold: true },              
              { t: "con un approccio sistemico, multidimensionale e multi-situato, valorizzando interventi di cittadinanza attiva e di " },
              { t: "educazione alla cittadinanza globale", accent: true, bold: true },
              { t: ", con attenzione particolare ai temi della pace e della solidarietà." },              
            ]
        },
        //FINE PERSONE
        //PIANETA
        20: {   numero: "A",
            attiva: true,
            colore: "#E91E8C",
            testo: [
              { t: "Promuovere e svolgere azioni miranti a rafforzare la  " },
              { t: "competitività del Nord-Ovest ", accent: true, bold: true },
              { t: "in un quadro di competitività " },
              { t: "europea ed extra-EU", accent: true, bold: true },
              { t: ": sostegno all’ecosistema della ricerca nell’accesso alle opportunità europee anche in ambito di innovazione dirompente." },              
            ]
        },
        21: {   numero: "B",
            attiva: true,
            colore: "#E91E8C",
            testo: [
              { t: "Favorire la " },
              { t: "connessione tra ", accent: true, bold: true },
              { t: "risultati della "},
              { t: "ricerca e opportunità di mercato ", accent: true, bold: true },
              { t: "grazie a strumenti evoluti di trasferimento tecnologico anche con carattere di premialità rispetto ai risultati, attrazione competenze specifiche e attrazione di finanza " },
              { t: "early-stage", italic: true },
              { t: ". In logica post PNRR, focus sui risultati dei progetti eseguiti e quelli " },
              { t: "ongoing", italic: true },
              { t: "." },
            ]
        },
        22: {   numero: "C",
        attiva: true,
        colore: "#0084D5",
        testo: [
          { t: "Sostenere il percorso di consolidamento del territorio nell’ambito dell’" },
          { t: "intelligenza artificiale ", accent: true, bold: true },
          { t: "tramite programmi complementari a " },
          { t: "AI4Industry ", accent: true, bold: true },
          { t: "(AI4I) e iniziative esplorative in logica " },
          { t: "the next big thing", italic: true },
          { t: ", come robotica e aerospazio, promuovendo raccordi con gli epicentri mondiali dell’innovazione." },                    
        ]
        },
        23: {   numero: "D",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Favorire " },              
              { t: "attrazione e ", accent: true, bold: true },
              { t: "retention ", accent: true, bold: true, italic: true },
              { t: "di giovani innovatori", accent: true, bold: true },
              { t: ", talenti imprenditoriali e studenti dall’Italia e dal resto del mondo tramite l’offerta di opportunità di formazione ed esperienze tra imprese e accademia." },              
            ]
        },
        24: {   numero: "E",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Accompagnare gli " },
              { t: "Atenei del Nord-Ovest ", accent: true, bold: true },
              { t: "nel loro percorso di " },
              { t: "miglioramento continuo ", accent: true, bold: true },
              { t: "attraverso programmi funzionali alle loro tre missioni fondamentali (ricerca, didattica con nuovi modelli formativi, terza missione). Operare a favore di una maggiore " },
              { t: "sinergia tra le Università ", accent: true, bold: true },
              { t: "del Nord-Ovest, anche in merito alle infrastrutture di ricerca." },                            
            ]
        },
        25: {   numero: "A",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Sostenere progetti che potenzino e completino l’" },
              { t: "l’ecosistema dell’innovazione nel Nord-Ovest", accent: true, bold: true },
              { t: ". Sostenere gli hub fisici e digitali, i nuovi orientamenti di incubatori e acceleratori, nuove modalità di accesso e ingresso di talenti nell’ecosistema. Potenziare le collaborazioni con gli "},
              { t: "ecosystem builder", italic: true },              
              { t: "." },
            ]
        },
        26: {   numero: "B",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Agire sulla progettazione e sulla realizzazione di iniziative orientate alla " },
              { t: "transizione tecnologica nel Terzo Settore e nella PA", accent: true, bold: true },
              { t: ", sostenendo la cultura dell’innovazione continua. Abilitare l’"},
              { t: "upskilling ", italic: true },
              { t: "e il " },
              { t: "reskilling ", italic: true },
              { t: "nelle competenze tecnologiche con specifico riferimento all’impatto dell’IA sui lavori del futuro, valorizzando in logica " },
              { t: "Seal of Excellence ", italic: true },
              { t: "le iniziative sviluppate in ambito Fondo Repubblica Digitale. Sostegno al percorso d’innovazione e d’introduzione di tecnologie emergenti nel quadro di " },
              { t: "Torino Neutral City 2030", italic: true },
              { t: "." },
            ]
        },
        27: {   numero: "C",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Concretizzare percorsi di "},
              { t: "trasformative procurement ", italic: true },
              { t: "sostenendo progetti di " },
              { t: "competitività nell’economia sociale", accent: true, bold: true },
              { t: ". Innovazione dei processi organizzativi, di prodotto e nei modelli di business. Accesso a investimenti e a risorse finanziarie pubbliche di matrice europea e nazionale."},
            ]
        },
        28: {   numero: "D",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Innovazione e imprenditorialità: opportunità per la " },
              { t: "realizzazione professionale e personale dei giovani ", accent: true, bold: true },
              { t: "attraverso percorsi di formazione su imprenditorialità, propensione al rischio e gestione del fallimento. Creare occasioni di ingaggio e " },
              { t: "incontro con startup e imprese", accent: true, bold: true },
              { t: ", valorizzando le conoscenze acquisite in linea con l’approccio europeo alle microcredenziali per l’apprendimento permanente."},                            
            ]
        },
        29: {   numero: "E",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Promuovere l’" },
              { t: "innovazione tra infrastrutture d’impatto e cambiamento sistemico", accent: true, bold: true },
              { t: ". Accompagnare la Pubblica Amministrazione a sperimentare ", accent: true },
              { t: "Proof of Concept ", italic: true },
              { t: "(PoC) che incorporino elementi di trasformazione sostenibile dei territori, contribuendo a modernizzare le politiche d’innovazione e formulare modelli d’azione replicabili." },              
            ]
        },
        30: {   numero: "A",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Sostenere azioni di innovazione nel sistema sanitario, nel quadro della programmazione regionale, attraverso contributi per " },
              { t: "grandi attrezzature e nuovi modelli operativi ", accent: true, bold: true },
              { t: "che offrano maggiore intensità d’uso, flessibilità e sostenibilità. Supporto allo ", },
              { t: "sviluppo di reti ", accent: true, bold: true },
              { t: "di enti non-profit la cui missione è sostenere gli ospedali, anche nell’ottica di sperimentazione e scalabilità in un rinnovato patto fiduciario." },              
            ]
        },
        31: {   numero: "B",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Sostenere progetti che abilitino la " },
              { t: "transizione tecnologica della sanità ", accent: true, bold: true },
              { t: "nelle sue varie declinazioni, contribuendo così a rendere i " },
              { t: "servizi sanitari più affidabili ed accessibili", accent: true, bold: true },
              { t: ", efficienti e centrati sul paziente, sfruttando il potenziale trasformativo delle basi dati per la generazione di cambiamenti sistemici." },              
            ]
        },
        32: {   numero: "C",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Favorire il percorso di " },
              { t: "riconoscimento di nuovi IRCCS ", accent: true, bold: true },
              { t: "sul territorio regionale, come opportunità in grado di combinare ricerca scientifica di eccellenza con pratica clinica innovativa." },          
            ]
        },
        33: {   numero: "D",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Adottare un " },
              { t: "approccio ", accent: true, bold: true },
              { t: "Circular-Health ", accent: true, bold: true, italic: true },
              { t: "che consideri la salute influenzata da una moltitudine di fattori esterni tra loro interconnessi che superano la dimensione propriamente biomedica. Focus particolare su impatti del degrado ambientale, dei cambiamenti climatici e degli effetti della nutrizione sulla salute." },              
            ]
        },
        34: {   numero: "E",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Promuovere la " },
              { t: "pratica di attività fisica e sportiva ", accent: true, bold: true },
              { t: "e l’adozione di stili di vita sani con specifico riferimento all’educazione alla nutrizione, attraverso azioni mirate sui determinanti di salute e sull’integrazione con il sistema scolastico." },              
            ]
        },

        35: {   numero: "A",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Operare su " },
              { t: "iniziative e progetti focalizzati sul rilancio e il rafforzamento dei territori", accent: true, bold: true },
              { t: ", accompagnando le " },
              { t: "istituzioni ", accent: true, bold: true },
              { t: "nella definizione di " },
              { t: "piani di sostenibilità e crescita ", accent: true, bold: true },
              { t: " e attivando in modo proattivo e concreto " },
              { t: "azioni di valorizzazione degli asset strategici locali", accent: true, bold: true },
              { t: "." },
            ]
        },

        36: {   numero: "B",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Collaborare con istituzioni, comunità e cittadinanza anche attraverso " },
              { t: "percorsi di capacity building avanzato", accent: true, bold: true },
              { t: ", con l’obiettivo di facilitare l’accesso alle opportunità di sostegno previste dalla programmazione regionale, nazionale ed europea." },              
            ]
        },
        37: {   numero: "C",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Adottare una " },
              { t: "prospettiva globale", accent: true, bold: true },
              { t: ", analizzando trend e buone pratiche legate ai temi dello sviluppo e "},
              { t: "dialogando con i principali stakeholder internazionali ", accent: true, bold: true },
              { t: "attivi in questi ambiti, al fine di promuovere, in una logica di "},
              { t: "advocacy",italic: true },
              { t: ", iniziative regionali allineate con gli obiettivi condivisi."},              
            ]
        },
        38: {   numero: "D",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Collaborare con il " },
              { t: "sistema produttivo", accent: true, bold: true },
              { t: ", che consideriamo un attore essenziale per l’attivazione di politiche orientate alla crescita economica e sostenibile dei territori." },              
            ]
        },
        39: {   numero: "E",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Supportare l'" },
              { t: "l’emersione e il rafforzamento di leadership locali generative", accent: true, bold: true },
              { t: ", anche giovanili e femminili, a favore di " },
              { t: "iniziative flagshipc", accent: true, bold: true },
              { t: " per lo ", },
              { t: "sviluppo del territorio", accent: true, bold: true },
              { t: "." },                            
            ]
        },

        40: {   numero: "A",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Promuovere iniziative che favoriscano la " },
              { t: "rigenerazione degli ecosistemi", accent: true, bold: true },
              { t: ", l’incremento e/o ripristino del capitale naturale e la " },
              { t: "tutela della biodiversità", accent: true, bold: true },
              { t: ", agendo nel rispetto dei limiti planetari sicuri e giusti. Co-progettazione di selezionati progetti " },
              { t: "flagship ", italic: true },              
              { t: " in questo campo." },              
            ]
        },
        41: {   numero: "B",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Promuovere un " },
              { t: "approccio integrato tra sostenibilità ambientale e salute circolare", accent: true, bold: true },
              { t: "che riconosca le interconnessioni tra la salute umana, animale e ambientale, in particolare relativamente al tema dell’ecoansia, dei sistemi del cibo e dell’antibiotico-resistenza." },              
            ]
        },
        42: {   numero: "C",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Promuovere la " },
              { t: "cultura della sostenibilità ambientale", accent: true, bold: true },
              { t: ", della protezione rispetto ai rischi dei fenomeni climatici estremi e del volontariato ambientale. Incentivare la " },
              { t: "partecipazione e il coinvolgimento delle comunità", accent: true, bold: true },
              { t: ", del Terzo Settore e delle istituzioni, in pratiche e comportamenti di sostenibilità ambientale anche rispetto ai comportamenti da tenersi in caso di crisi ed emergenze"},          
            ]
        },
        43: {   numero: "D",
            attiva: true,
            colore: "#0084D5",
            testo: [
              { t: "Promuovere azioni di accompagnamento degli sforzi di " },
              { t: "adattamento ", accent: true, bold: true },
              { t: "al cambiamento climatico e l’adozione di misure di " },
              { t: "prevenzione dagli eventi climatici estremi", accent: true, bold: true },              
              { t: ", rafforzando la resilienza dei territori, anche in ambito socioeconomico e con una prospettiva intersezionale." },
            ]
        },
        44: {   numero: "E",
            attiva: true,
            colore: "#0084D5",
            testo: [              
              { t: "Accompagnare ", accent: true, bold: true },
              { t: "stakeholder ", italic: true },
              { t: "pubblici e privati nei processi di " },
              { t: "transizione energetica", accent: true, bold: true },              
              { t: ", per favorirne l’equità e la sostenibilità socioeconomica." },
            ]
        },
        //FINE PIANETA
        //CULTURA

        45: {   numero: "A",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Attivare, con i " },
              { t: "policy maker ", italic: true },
              { t: "territoriali, processi di definizione e realizzazione di strategie, piattaforme, programmi ed interventi di offerta culturale e turistica, al fine di sviluppare l’" },
              { t: "l’attrattività di reti, filiere e sistemi ", accent: true, bold: true },
              { t: "attraverso driver di posizionamento riconosciuti e condivisi." },              
            ]
        },
        46: {   numero: "B",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Sostenere proposte territoriali di valorizzazione culturale attraverso percorsi pluriennali di crescita, volti a sviluppare le opportunità che il " },
              { t: "turismo sostenibile ", accent: true, bold: true },              
              { t: "offre per ambiente, luoghi e comunità. " },              
            ]
        },
        47: {   numero: "C",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Sostenere l’offerta culturale di qualità dei territori attraverso azioni volte a favorire " },
              { t: "sinergie ", accent: true, bold: true },
              { t: "culturali e organizzative con esperienze " },
              { t: "nazionali e internazionali ", accent: true, bold: true },              
              { t: "e a incentivare la fruizione e i consumi culturali in particolare dei giovani." },                            
            ]
        },
        48: {   numero: "D",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Promuovere la " },
              { t: "produzione creativa e artistica", accent: true, bold: true },
              { t: ", specie giovanile, e processi culturali innovativi volti a sensibilizzare sulle grandi sfide del presente." },              
            ]
        },
        49: {   numero: "E",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Sostenere piani pluriennali di innovazione e transizione digitale degli enti del comparto culturale, con un’attenzione specifica allo sviluppo della " },
              { t: "cultura del dato ", accent: true, bold: true },              
              { t: " nella gestione, fruizione e valorizzazione dei patrimoni e a favorire il dialogo con l’ecosistema dell’innovazione." },              
            ]
        },

        50: {   numero: "A",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Favorire la penetrazione capillare e precoce dell’" },
              { t: "dell’esperienza culturale attiva ", accent: true, bold: true },              
              { t: "nei contesti educativi, formali e informali, e nelle comunità educanti, perché essa possa contribuire in modo significativo alla crescita e alla formazione dell’individuo e alla riduzione delle diseguaglianze." },              
            ]
        },
        51: {   numero: "B",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Garantire ai professionisti della cultura e per la cultura – con particolare riferimento a donne e giovani – " },
              { t: "risorse formative e professionalizzanti ", accent: true, bold: true },
              { t: "e percorsi di carriera capaci di abilitarli a essere promotori e attuatori della crescita del comparto culturale e della sua partecipazione allo sviluppo sostenibile dei territori."},                            
            ]
        },
        52: {   numero: "C",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Favorire l’evoluzione degli enti culturali secondo principi di " },
              { t: "responsabilità sociale e sviluppo sostenibile ", accent: true, bold: true },
              { t: "secondo la "},
              { t: "Green Transition", italic: true },
              { t: ", prioritariamente in chiave ecosistemica." },                    
            ]
        },
        53: {   numero: "A",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Sperimentare forme di " },
              { t: "partnership pubblico/private ", accent: true, bold: true },
              { t: "per favorire le opportunità di investimenti congiunti e per innovare gli interventi di conservazione e gestione dei beni culturali più rilevanti." },
            ]
        },
        54: {   numero: "B",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Promuovere la cultura della " },
              { t: "conservazione del patrimonio culturale ", accent: true, bold: true },              
              { t: "fondata su conoscenza, prevenzione e ricerca orientata allo sviluppo di un cambiamento sistemico nella tutela dei beni." },              
            ]
        },
        55: {   numero: "C",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Nel ruolo di socio fondatore delle più rilevanti istituzioni culturali nel Nord-Ovest, promuovere il " },
              { t: "rafforzamento degli asset culturali ", accent: true, bold: true },              
              { t: "come elemento qualificante del territorio in grado generare sviluppo, attrarre competenze e favorire una società equa e dinamica." },              
            ]
        },
        56: {   numero: "D",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Contribuire allo sviluppo di una " },
              { t: "riflessione critica sul paesaggio ", accent: true, bold: true },              
              { t: "attraverso il sostegno di progetti sperimentali che forniscano buone pratiche conservative e di transizione energetica e modelli efficaci di valutazione." },              
            ]
        },
        57: {   numero: "E",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Elaborare " },
              { t: "progetti di sistema ", accent: true, bold: true },              
              { t: "in ambito tecnologico, gestionale e organizzativo per " },
              { t: "archivi e biblioteche ", accent: true, bold: true },              
              { t: "da mettere a disposizione di tutti i soggetti del territorio." },              
            ]
        },
        58: {   numero: "A",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Studiare e disseminare " },
              { t: "conoscenza sui caratteri della partecipazione", accent: true, bold: true },
              { t: ": analizzare e disseminare i dati della partecipazione e dell’esclusione e del disinteresse; mettere a disposizione competenze e azioni sulla "},
              { t: "progettazione partecipata ", accent: true, bold: true },
              { t: "(" },
              { t: "citizen engagement", italic: true },
              { t: ", amministrazione condivisa co-progettazione/programmazione, partnership pubblico-privato, patti di collaborazione)." },                            
            ]
        },

        59: {   numero: "B",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Ampliare la domanda e la partecipazione culturale e diversificarne la base sociale favorendo un " },
              { t: "maggiore accesso alle esperienze culturali ", accent: true, bold: true },
              { t: "e incentivando un " },
              { t: "community welfare ", italic: true },
              { t: "caratterizzato dall'interazione tra cultura, salute e benessere con un'attenzione specifica per gli " },
              { t: "over 65", accent: true, bold: true },
              { t: "." },
            ]
        },

        60: {   numero: "C",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Incentivare la partecipazione attiva come uno degli elementi chiave che caratterizza lo stato della democrazia: ampliare l’alfabetizzazione politica, incoraggiare la diffusione del volersi e sapersi informare, " },
              { t: "ampliare ", accent: true, bold: true },              
              { t: "la cittadinanza scientifica e più in generale la " },                            
              { t: "cittadinanza attiva", accent: true, bold: true },
              { t: "." },
            ]
        },
        61: {   numero: "D",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Diffondere sui territori la partecipazione: " },
              { t: "rafforzare l’infrastruttura dei centri culturali ", accent: true, bold: true },
              { t: "e di aggregazione e la loro sostenibilità seguendo un principio di riequilibrio geografico (non solo aree urbane/aree montane, centro/quartieri ma anche tenendo conto delle fragilità comunali) per una " },
              { t: "rigenerazione territoriale ", accent: true, bold: true },              
              { t: "anche con usi mirati dello spazio pubblico. Sostenere esperienze culturali principalmente gratuite che si svolgano fuori da casa e dai luoghi convenzionali della cultura." },              
            ]
        },
        62: {   numero: "E",
            attiva: true,
            colore: "#CE0F69",
            testo: [
              { t: "Sostenere i e le giovani " },
              { t: "under 35 ", accent: true, bold: true },
              { t: "nel sentirsi motore della società e del suo sviluppo anche grazie a un "},
              { t: "dialogo intergenerazionale", accent: true, bold: true },
              { t: ": incentivare il loro impegno sociale e civico, il loro " },
              { t: "protagonismo ", accent: true, bold: true },
              { t: "nella vita democratica, favorendo la loro partecipazione alla " },
              { t: "governance ", italic: true },
              { t: "negli enti del Terzo Settore e in quelli pubblici e rafforzando le organizzazioni giovanili." },                            
            ]
        },

};

const formatDate = (dateStr) => {
    if (!dateStr || dateStr.length !== 8) return dateStr;
    return `${dateStr.substring(0, 2)}/${dateStr.substring(2, 4)}/${dateStr.substring(4)}`;
  };

const handleChipClick= (row) => {  
    console.log("CHIP",row);
    //fascicoli/10122024/proposteintervento/schede/125742
    //navigate()

    var url=properties.productionUrl+"/fascicoli/"+row+"/proposteintervento/schede/"+idScheda;        
    //var url="https://fascicolo.compagniadisanpaolo.it/fascicoli/"+row+"/proposteintervento/schede/"+idScheda;        
    console.log("URL",url);
    window.open(url+"?dt="+(new Date()).getTime());        
}


const handleChipClickWithMamma= (row, mamma) => {  
    console.log("CHIP",row);
    //fascicoli/10122024/proposteintervento/schede/125742
    //navigate()
    var url=properties.productionUrl+"/fascicoli/"+row+"/proposteintervento/schede/"+mamma;        
    //var url="https://fascicolo.compagniadisanpaolo.it/fascicoli/"+row+"/proposteintervento/schede/"+mamma;        
    console.log("URL",url);
    window.open(url+"?dt="+(new Date()).getTime());        
}

const handleTdClick= (row) => {  
    console.log("TD",row);
    //var url=properties.productionUrl+"/fileManager/files/premesse/"+idDossier+"/"+name;        
    var url=properties.productionUrl+"/fileManager/files/generated/"+dataSeduta+"/"+faseSeduta+"/allegati/"+idScheda+"/"+row.value;        
    console.log("URL",url);
    window.open(url+"?dt="+(new Date()).getTime());        
}

const showAlert = (value) => {  
    setAlert(
      <SweetAlert
      error
      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
      title={value}
      text="ciao"      
      onConfirm={() => { setAlert(null) }}
      //onCancel={() => { navigate(-1) }}
      confirmBtnCssClass="custom-btn custom-btn-success" 
      cancelBtnCssClass="custom-btn custom-btn-cancel"      
      confirmBtnText="Indietro"      
    >
    </SweetAlert>
    );
};

const toNumberIT = (value) => {
    if (value == null || value === "") return 0;
  
    let v = value;
  
    if (typeof v === "string" && v.includes(",")) {
      v = v.replaceAll(".", "").replace(",", ".");
    }
  
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };

  /* const sanitizeImporto = (value) => {
    if (!value) return "";      
    let v = value.replace(/[^0-9,]/g, "");      
    const parts = v.split(",");
    if (parts.length > 2) {
      v = parts[0] + "," + parts.slice(1).join("");
    }  
    return v;
  }; */

  function sanitizeImporto(value) {
    if (!value) return "";
  
    let v = value;
  
    if (typeof v === "string" && v.includes(",")) {
      v = v.replaceAll(".", "").replace(",", ".");
    }
  
    const n = Number(v);
    if (isNaN(n)) return "";
  
    return n.toFixed(2).replace(".", ",");
  }
  


    const handleEditorCommentChange = (content, editor) => {
        setCommentContent(content);
      };

      const handleEditorChange = (content, editor) => {
        setEditorContent(content);
      };
      const handleEditorIpotesiChange = (content, editor) => {
        setEditorIpotesi(content);
      };
      const handleEditorRuoloChange = (content, editor) => {
        setEditorRuolo(content);
      };
    
      const handleClickFabUpdate = (event) => {        
        
            console.log("handleClickFabLock",event);  
            //doPostUpdate (idScheda, praticaBloccataOriginalField, "newValue",String(!praticaBloccata));                          
            doPostGenerateGSFCard(idScheda,formatDateISO(dataSeduta),faseSeduta);
        
    };  
      
    
      const handleClickFabLock = (event) => {        
        //if( properties.verboseLog==1)
            console.log("handleClickFabLock0",praticaBloccataOriginalField);  
            console.log("handleClickFabLock",event,idScheda,praticaBloccataOriginalField,String(!praticaBloccata), !praticaBloccata);  
            doPostUpdate (idScheda, praticaBloccataOriginalField, "newValue",String(!praticaBloccata));                          
            setPraticaBloccata(!praticaBloccata);
            //console.log("handleClickFabLock",praticaBloccataOriginalField,praticaBloccata);  
    };  

    const passing2 = (event) => {        
        if( properties.verboseLog==1)
            console.log("passing2",event);    
        hiddenFileUpload2.current.files=null;
        if( properties.verboseLog==1)
            console.log("42",hiddenFileUpload2);    
        hiddenFileUpload2.current.click();
    };
    //ALLEGATI
    const [openAllegati, setOpenAllegati] = useState(false);
    const [tableAllegati, setTableAllegati] = useState([]);

    const handleOpenAllegati = () => {     
        console.log("OPEN ALLEGATI",homeData);
        const allegati= homeData.filter(item => item.tipo == "allegato")
            .map((item, index) =>  (item));
                    
        setTableAllegati(allegati);                
        console.log("ALLE",allegati);
        setOpenAllegati(true);
    };

    const handleCloseAllegati = () => {            
        setOpenAllegati(false);
      };
    
    const handleDeleteRow = (rowKey) => {
        setTableAllegati(prev =>
          prev.filter(row => row.key !== rowKey)
        );
    };


    const handleSaveAllegati = () => {        
        console.log("Salvataggio:", tableAllegati);      
        //doPostUpdate (idScheda, "allegati", "allegato",file.name);
        doPostUpdate (idScheda, "allegati", "allegati",JSON.stringify(tableAllegati));        
        setOpenAllegati(false);
    };



    const hasFilteredRows = (table) => {
        return table
          ?.slice(2)
          .some(row => row[4] !== "0,00" || row[5] !== "0,00");
      };

      const attachmentsAvailable = (home) =>{
        //console.log("DDDD",home);
        return Array.isArray(home) &&
        home.length > 0 &&
        home.some(item => item.tipo === "allegato");
      };
    //ALLEGATI

// PER DETTAGLIO SPLIT BUDGET
    const [tableContent, setTableContent] = useState([]);
    const [openDettaglioBudget, setOpenDettaglioBudget] = useState(false);
    const visibleDettaglioCols = [3, 4, 5];
    const handleCloseDettaglioBudget = () => {    
        setOpenDettaglioBudget(false);
    };
    const handleOpenDettaglioBudget = (item) => {
        console.log("OPEN22", item, homeData)
        let val=item.table;
        setTableContent(val);        
        setItemContent(item);     
        if(homeData.find(item => item.label === "Importo Anno In Corso").newValue != undefined){
            setEditorAnnoInCorso(sanitizeImporto(homeData.find(item => item.label === "Importo Anno In Corso")?.newValue));
        }
        else{
            setEditorAnnoInCorso(sanitizeImporto(homeData.find(item => item.label === "Importo Anno In Corso")?.value));
        }
        if(homeData.find(item => item.label === "Importo Anno Precedente").newValue != undefined){
            setEditorAnnoPrecedente(sanitizeImporto(homeData.find(item => item.label === "Importo Anno Precedente")?.newValue));
        }
        else{
            setEditorAnnoPrecedente(sanitizeImporto(homeData.find(item => item.label === "Importo Anno Precedente")?.value));
        }          
        setOpenDettaglioBudget(true);
        };
  
    const handleSaveDettaglioBudget = () => {        
        console.log("Salvato:", tableContent,itemContent);      
        if( tableContent.slice(2).reduce((acc, row) =>
        acc + (parseFloat(row[4].replace(/\./g, "").replace(",", ".")) || 0),0) !== parseFloat(editorAnnoInCorso) )
        showAlert("La divisione dell'importo proposto tra le diverse missioni non è corretta. Correggere per poter salvare.");

        else{
        doPostUpdate (idScheda, itemContent.originalField, "table",JSON.stringify(tableContent));        
        setOpenDettaglioBudget(false);
        }
    };
    
    const handleChangeElementiStrategia = async (value) => {
        console.log("VVVVV",value)
        if(value != elementiStrategia){
            console.log("AAAAAAA", value);    
            console.log("BBBBBBB", elementiStrategia);
        }
        else
        {
            console.log("DDDDDDD", value);    
            console.log("EEEEEEE", elementiStrategia);
        }
        console.log(idScheda, "007-"+idScheda+"-appoggio-ElementidiStrategia", );
        
        //setElementiStrategia(value);
                
        //const newData = [...tableContent];
        //newData[rowIndex][colIndex] = value;
        //setTableContent(newData);

        try {
            await doPostUpdatePromise(idScheda, "007-"+idScheda+"-appoggio-ElementidiStrategia", "newValue",JSON.stringify(value), false);            
          } catch (err) {
            console.error("Errore nel salvataggio", err);
        }
        setElementiStrategia(value);
      };


    const handleChangeInTable = (rowIndex, colIndex, value) => {
        const newData = [...tableContent];
        newData[rowIndex][colIndex] = value;
        setTableContent(newData);
      };


    const handleDeleteChip = (valueToRemove, event) => {
        event.stopPropagation();   // impedisce che il click apra la Select
        const newValues = formatModel.filter((v) => v !== valueToRemove);
        handleChangeSelectTemplate(newValues);
    };
    
    const handleChangeSelectTemplate=  ( values) => {
            setFormatModel(values);
            
            //let ret=value;
        const parts = values.map((value, index) => {
            const isLast = index === values.length - 1;    
            const divider = isLast ? null : (
                <hr
                  key={`divider-${value}`}
                  style={{
                    border: 'none',
                    borderTop: '1px dashed #CCCCCC',
                    margin: '12px 0',
                  }}
                />
              );
        if(value==1)
            return(
                <React.Fragment key={value}>
                <span>
                Si propone di approvare lo stanziamento di € <span style={{ color: 'red' }}> [Importo] </span>, a valere sui fondi <span style={{ color: 'red' }}>[Anno] </span> per l’Obiettivo <span style={{ color: 'red' }}>[Obiettivo]</span>, Missione <span style={{ color: 'red' }}>[Missione]</span>, a favore di <span style={{ color: 'red' }}>[Denominazione Ente + Sede Legale ovvero Città + Provincia]</span> per <span style={{ color: 'red' }}>[Finalità del progetto/intervento]</span>. <br/>Quanto precede con delega al Segretario Generale per <em style={{ color: 'red' }}> [tenere peraltro conto che in base all’articolo 18 dello statuto il Segretario Generale «provvede all’esecuzione delle deliberazioni del Consiglio Generale e del Comitato di Gestione e parimenti esegue le decisioni del Presidente»] </em>.
                <br/><br/>
                <em style={{ color: 'red' }}>Altre possibili imputazioni dei fondi (a titolo puramente esplicativo e non esaustivo): </em><br/>
                • € <span style={{ color: 'red' }}>[Importo] </span>, a valere sull’accantonamento di € <span style={{ color: 'red' }}>[Importo]</span> disposto nella riunione del <span style={{ color: 'red' }}> [Data] </span> per <span style={{ color: 'red' }}>[Data della Riunione in cui era stato deliberato l’accantonamento e le sue finalità. </span> <em style={{ color: 'red' }}>L’indicazione del numero della pratica nell’ipotesi di intervento può essere mantenuta anche se non ha valenza informativa per i componenti il CdG in quanto essi non accedono all’applicativo Eroweb]</em>;<br/>
                • € <span style={{ color: 'red' }}>[Importo] </span>, a valere su fondi residui di accantonamenti disposti in anni precedenti per le stesse finalità. <em style={{ color: 'red' }}>[Trattandosi di richiami a più pratiche sul verbale non vengono riportate le date di ciascuna riunione]</em>.<br/>
                • € <span style={{ color: 'red' }}>[Importo] </span>a valere sui fondi in attesa di destinazione;<br/>
                • € <span style={{ color: 'red' }}>[Importo] </span>a valere sui fondi riassorbiti e destinati a <span style={{ color: 'red' }}>[Obiettivo/Missione/Progetto]</span>;<br/>
                • € <span style={{ color: 'red' }}>[Importo] </span>a valere sui fondi per le erogazioni ex art. 1, comma 47, Legge 178/2020 <span style={{ color: 'red' }}>[Obiettivi/Missioni] </span> per <span style={{ color: 'red' }}>[Finalità]</span>.
                <br/><br/>
                <em style={{ color: 'red' }}>
                <strong>N.B. Condizionalità:</strong> qualora sussistano delle condizioni da riportare in delibera occorra esplicitarle nell’ipotesi di intervento e non solo nell’executive summary. 
                Quanto precede a condizione che …
                </em>
                </span>
        {divider}
      </React.Fragment>
            );
        if(value==2)
            return(
                <React.Fragment key={value}>
                <span>
                Si propone di autorizzare l’accantonamento di € <span style={{ color: 'red' }}>[Importo]</span>, a valere sui fondi <span style={{ color: 'red' }}>[Anno] </span> per l’Obiettivo <span style={{ color: 'red' }}>[Obiettivo]</span>, Missione <span style={{ color: 'red' }}>[Missione]</span>, per <span style={{ color: 'red' }}>[Finalità]</span>. Quanto precede con delega al Segretario Generale per l’utilizzo di tale importo e per l'approvazione dei relativi contributi <em style={{ color: 'red' }}>[laddove sia un'attività necessaria]</em>. <br/><br/>
            
                <em style={{ color: 'red' }}>Altre possibili imputazioni dei fondi (a titolo puramente esplicativo e non esaustivo): </em><br/>
                • € <span style={{ color: 'red' }}>[Importo] </span> a valere sui fondi in attesa di destinazione;<br/>
                • € <span style={{ color: 'red' }}>[Importo] </span> a valere sui fondi riassorbiti nella riunione del <span style={{ color: 'red' }}> [Data] </span> e destinati a <span style={{ color: 'red' }}>[Obiettivo/Missione/Progetto]</span> <br/>
                • € <span style={{ color: 'red' }}>[Importo] </span> a valere sui fondi per le erogazioni ex art. 1, comma 47, Legge 178/2020 per <span style={{ color: 'red' }}>[Finalità]</span>;
                <br/><br/>
                <em style={{ color: 'red' }}>
                <strong>N.B. Condizionalità:</strong> qualora sussistano delle condizioni da riportare in delibera occorra esplicitarle nell’ipotesi di intervento e non solo nell’executive summary. 
                Quanto precede a condizione che …
                </em>
                </span>
                {divider}
      </React.Fragment>);            
        if(value==3)
            return(
                <React.Fragment key={value}>
                <span>
                Si richiede di approvare <em style={{ color: 'red' }}>[inserire la specifica se si tratta di bandi/linee guida]</em> e di conferire delega al Segretario Generale per apportare modifiche non sostanziali che si rendessero ancora necessarie od opportune. <br/>
                Si chiede inoltre di autorizzare un accantonamento di € <span style={{ color: 'red' }}>[Importo] </span>, a valere su <em style={{ color: 'red' }}>[specificare]</em>, per la relativa dotazione. <br/>
                Si richiede di conferire delega al Segretario Generale per approvare gli esiti del <em style={{ color: 'red' }}>[inserire la specifica se si tratta di bandi/linee guida]</em> nella fase intermedia e/o finale.
                <br/><br/>
                <em style={{ color: 'red' }}>
                <strong>N.B. Condizionalità:</strong> qualora sussistano delle condizioni da riportare in delibera occorra esplicitarle nell’ipotesi di intervento e non solo nell’executive summary. 
                Quanto precede a condizione che …
                </em>
            </span>
                {divider}
      </React.Fragment>);     
        if(value==4)
            return(
                <React.Fragment key={value}>
                <span>
                Si richiede al Comitato di Gestione, verificata la coerenza dei progetti in graduatoria <em style={{ color: 'red' }}>[laddove questa sia prevista]</em> con le <em style={{ color: 'red' }}>[inserire la specifica se si tratta di bandi/linee guida]</em>, di approvare:<br/> 
                •	gli esiti della selezione condotta; <br/>
                •	i seguenti stanziamenti per complessivi € <span style={{ color: 'red' }}>[Importo] </span>, a valere su <em style={{ color: 'red' }}>[specificare]</em>.<br/><br/>
                <em style={{ color: 'red' }}>Ai fini della rappresentazione in calce alla delibera di approvazione degli stanziamenti, <strong>va trasmesso alla Segreteria il prospetto utilizzato per la pubblicazione sul sito della Fondazione </strong>(laddove questo pubblicato).</em>
                <br/><br/>
                <em style={{ color: 'red' }}>
                    <strong>N.B. Condizionalità:</strong> qualora sussistano delle condizioni da riportare in delibera occorra esplicitarle nell’ipotesi di intervento e non solo nell’executive summary. 
                    Quanto precede a condizione che …
                    </em>
                </span>
                {divider}
                </React.Fragment>);  
        if(value==5)
            return(
                <React.Fragment key={value}>
                <span>
                Si richiede di approvare <em style={{ color: 'red' }}>[inserire la specifica se si tratta di convenzione/protocollo d’intesa/ accordo quadro]</em>, e di conferire delega al Segretario Generale per apportare modifiche non sostanziali che si rendessero ancora necessarie od opportune. <br/>
                Si richiede, inoltre, di conferire delega al Presidente e/o al Segretario Generale, in via disgiunta fra di loro <em style={{ color: 'red' }}>[in caso si intenda conferire a entrambi]</em>, per la sottoscrizione del documento.
            
                <br/><br/>
                <em style={{ color: 'red' }}>
                    <strong>N.B. Condizionalità:</strong> qualora sussistano delle condizioni da riportare in delibera occorra esplicitarle nell’ipotesi di intervento e non solo nell’executive summary. 
                    Quanto precede a condizione che …
                </em>
                <br/><br/>
                <em style={{ color: 'red' }}>
                    <strong>N.B.:</strong>  In alcuni casi, in cui non ci sia impegno finanziario definito, il Segretario Generale e/o il Presidente possono firmare convenzioni/protocolli d’intesa/accordi quadro senza passaggio preventivo al Comitato di Gestione.
                </em>
                </span>
                {divider}
                </React.Fragment>);  
        if(value==6)
            return(
                <React.Fragment key={value}>
                <span>
                    Si richiede al Comitato di Gestione di esprimersi sulle proposte di modifica allo statuto di <span style={{ color: 'red' }}>[Ente] </span>. Quanto precede con delega al Presidente e al Segretario Generale, in via disgiunta fra di loro, per proporre ulteriori modifiche di carattere tecnico-formale che si rendessero ancora necessarie od opportune.
                </span>
                {divider}
                </React.Fragment>);  
        if(value==7)
            return(
                <React.Fragment key={value}>
                <span>
                    Si chiede di prendere atto dell’informativa resa sul <span style={{ color: 'red' }}>[Progetto/Iniziativa/Attività] </span> svolta nel periodo da <span style={{ color: 'red' }}>[Data] </span> a <span style={{ color: 'red' }}>[Data] </span>.
                </span>
                {divider}
                </React.Fragment>);  
        if(value==8)
            return(
                <React.Fragment key={value}>
                <span>
                Si chiede di esprimere parere di massima su   <em style={{ color: 'red' }}>[specificare oggetto]</em>. <br/>
                <em style={{ color: 'red' }}><strong>N.B. </strong> Per cortesia istituzionale verso un organo è opportuno chiedere solo di esprimersi (non esprimere parere di massima favorevole).</em>
                </span>
                {divider}
                </React.Fragment>);  
        if(value==9)
            return(
                <React.Fragment key={value}>
                <span>
                Si richiede al Comitato di Gestione di approvare € <span style={{ color: 'red' }}>[Importo]</span> quale ridestinazione del residuo del contributo di € <span style={{ color: 'red' }}>[Importo]</span>, disposto nella seduta del <span style={{ color: 'red' }}>[Data] </span> a favore di <span style={{ color: 'red' }}>[Denominazione Ente] </span>.
                </span>
                {divider}
                </React.Fragment>);  
        if(value==10)
            return(
                <React.Fragment key={value}>
                <span>
                Si chiede al Comitato di Gestione di: <br/>
                •	esprimere parere sul nuovo progetto pluriennale <span style={{ color: 'red' }}>[Denominazione]</span>, del valore complessivo di € <span style={{ color: 'red' }}>[Importo]</span>, per il periodo <span style={{ color: 'red' }}>[Periodo]</span>;<br/>
                •	autorizzare un accantonamento di € <span style={{ color: 'red' }}>[Importo]</span>, a valere su <em style={{ color: 'red' }}>[specificare]</em> per <span style={{ color: 'red' }}>[Finalità]</span>; <br/>
                •	approvare uno stanziamento di € <span style={{ color: 'red' }}>[Importo]</span>, a valere su <em style={{ color: 'red' }}>[specificare]</em>  per le attività della prima annualità del progetto; <br/>
                •	conferire delega al Presidente e al Segretario Generale, in via disgiunta tra di loro, per tutti gli adempimenti connessi. <em style={{ color: 'red' }}>[Da valutare a seconda dei casi]</em>.
            </span>
                {divider}
                </React.Fragment>);  
        });
        //setSuggestion (ret);
        setSuggestion(parts.filter(Boolean).length > 0 ? parts : null);
        //setFormatModel(value)
      };

    function getMoneyAsStringFromDouble(value, withEuro = false) {
        //console.log(value);        
        if(value.includes(",")){
            value=value.replaceAll(".","");
            value=value.replaceAll(",",".");
        }
        //console.log("S1",value);
        value = Number(value);
        const formatter = new Intl.NumberFormat('it-IT', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
          useGrouping: "always"
        });
      
        const formatted = formatter.format(value);
        //console.log("S2",formatted);;
        return withEuro ? `${formatted} €` : formatted; 
       
    }  

    const handleChangeInAllegatiTable = (rowIndex, field, value) => {
        //handleChangeInAllegatiTable(rowIndex, "label", e.target.value)
        const newData = [...tableAllegati];
        newData[rowIndex][field] = value;
        setTableAllegati(newData);
      };
//
    //START EXECUTIVE SUMMARY
    const [editorExecutive, setEditorExecutive] = useState('');
    const [editorRelazione, setEditorRelazione] = useState('');
    const [openER, setOpenER] = useState(false);
    const [itemRelazione, setItemRelazione] = useState('');
    const handleOpenER = (item) => {
        console.log("OPENER",item);        
        let val= item.newValue || item.value
        let val2= relazioneData.length > 0 ? relazioneData[0] : null;
        setItemRelazione(val2);
        if(val2!= null)
        val2=val2.newValue || val2.value;
        console.log ("OO", val, val2)
        setItemContent(item);
        setEditorExecutive(val || '');
        setEditorRelazione(val2 || '');
        setCommentContent(item.comment||'');
        setOpenER(true);
        };
      
    const handleCloseER = () => {        
        setCommentContent('');
        setItemRelazione('');
        setOpenER(false);
    };
      
    //const handleSaveER = () => {        
      const handleSaveER = async () => {        
          console.log("Salvato:1", editorExecutive);
          console.log("Salvato:2", editorRelazione);                 
          console.log("Salvato:4", commentContent);     
/*                     
          doPostUpdate (idScheda, itemContent.originalField, "newValue",editorExecutive);
          doPostUpdate (idScheda, itemRelazione.originalField, "newValue",editorRelazione);             
          doPostUpdate (idScheda, itemContent.originalField, "comment",commentContent);   
*/
         try {
            await doPostUpdatePromise(idScheda, itemContent.originalField, "newValue",editorExecutive, false);        
            await doPostUpdatePromise(idScheda, itemRelazione.originalField, "newValue",editorRelazione,false);
            await doPostUpdatePromise(idScheda, itemContent.originalField, "comment",commentContent,true);
        } catch (err) {
            console.error("Errore nel salvataggio", err);
        }
          setCommentContent('');     
          setItemRelazione('');
          setOpenER(false);
    };

    const handleEditorExecutiveChange = (content, editor) => {
            setEditorExecutive(content);
    };    
    const handleEditorRelazioneChange = (content, editor) => {
            setEditorRelazione(content);
    };    
    //FINE EXECUTIVE SUMMARY
    
    //PER IPOTESI INTERVENTO
    const [editorRuolo, setEditorRuolo] = useState('');
    const [editorIpotesi, setEditorIpotesi] = useState('');
    //const [editorImporto, setEditorImporto] = useState('');

    const handleOpenII = (item) => {
        console.log("OPENII",item);
        //let val=item.value;
        let val= item.newValue || item.value
        let val2=item.second;
        //console.log("HOII",item);
        //val=val.replaceAll('</p>', '</p><p><br></p>')
        //val2=val2.replaceAll('</p>', '</p><p><br></p>')
        //console.log("VAL",val2);
        setItemContent(item);
        setEditorIpotesi(val || '');
        setEditorRuolo(val2 || '');
        setCommentContent(item.comment||'');
        setOpenII(true);
        };
      
        const handleCloseII = () => {    
            //console.log("Close:", editorContent);      
            setCommentContent('');
            setOpenII(false);
          };
      
        //const handleSaveII = () => {
        const handleSaveII = async () => {                
          console.log("Salvato:1", editorIpotesi);
          console.log("Salvato:2",  editorRuolo);           
          console.log("Salvato:4", commentContent);      
          
          //doPostUpdate (idScheda, itemContent.originalField, "newValue",editorIpotesi);
          //doPostUpdate (idScheda, itemContent.originalField, "secondValue",editorRuolo);             
          //doPostUpdate (idScheda, itemContent.originalField, "comment",commentContent);  
          
          try {
            await doPostUpdatePromise(idScheda, itemContent.originalField, "newValue",editorIpotesi, false);        
            await doPostUpdatePromise(idScheda, itemContent.originalField, "secondValue",editorRuolo, false);
            await doPostUpdatePromise(idScheda, itemContent.originalField, "comment",commentContent,true);
        } catch (err) {
            console.error("Errore nel salvataggio", err);
        }

          

          setCommentContent('');
          //}
          setOpenII(false);
        };

    //PER IPOTESI INTERVENTO

    //IMPORTO PROPOSTO
    const [openImporto, setOpenImporto] = useState(false);
    const [editorAnnoInCorso, setEditorAnnoInCorso] = useState('');
    const [editorAnnoPrecedente, setEditorAnnoPrecedente] = useState('');

    const handleOpenImportoProposto = (val) => {    
        console.log("HO",val, homeData.find(item => item.label === "Importo Anno In Corso").newValue);
        setItemContent(val);   
        if(homeData.find(item => item.label === "Importo Anno In Corso").newValue != undefined){
            setEditorAnnoInCorso(sanitizeImporto(homeData.find(item => item.label === "Importo Anno In Corso")?.newValue));
        }
        else{
            setEditorAnnoInCorso(sanitizeImporto(homeData.find(item => item.label === "Importo Anno In Corso")?.value));
        }
        if(homeData.find(item => item.label === "Importo Anno Precedente").newValue != undefined){
            setEditorAnnoPrecedente(sanitizeImporto(homeData.find(item => item.label === "Importo Anno Precedente")?.newValue));
        }
        else{
            setEditorAnnoPrecedente(sanitizeImporto(homeData.find(item => item.label === "Importo Anno Precedente")?.value));
        }        
        setOpenImporto(true);
    };

    const handleCloseImportoProposto = () => {    
        //console.log("Close:", editorContent);      
        setOpenImporto(false);
    };

    const handleChangeImportoProposto = ( field, value) => {
        console.log("HCIP",field,value);
        if(field=="Importo Anno In Corso")
            setEditorAnnoInCorso(value);
        if(field=="Importo Anno Precedente")
            setEditorAnnoPrecedente(value);        
      };

    //const handleSaveImportoProposto = () => {
    const handleSaveImportoProposto = async () => {   
      
      console.log("Salvando", itemContent);      
      if(parseFloat(editorAnnoInCorso.replace(/\./g, "").replace(",", ".")) + 
        parseFloat(editorAnnoPrecedente.replace(/\./g, "").replace(",", ".")) !==
        parseFloat((homeData.find(item => item.label === "Importo Proposto")?.value || 0))) {
            showAlert("La divisione tra importo anno in corso ed importo anno precedente non corrisponde all'importo proposto. Correggere per poter salvare.");
      }
      else{      
        let aic= itemContent.originalField.replace("ImportoProposto","ImportoAnnoInCorso");
        let ap= itemContent.originalField.replace("ImportoProposto","ImportoAnnoPrecedente");
        console.log("Salvando", aic);      
        console.log("Salvando", ap);      
        //doPostUpdate (idScheda, aic, "newValue",editorAnnoInCorso);
        //doPostUpdate (idScheda, ap, "newValue",editorAnnoPrecedente);
        try {
            await doPostUpdatePromise(idScheda, aic, "newValue",editorAnnoInCorso,false);          
            await doPostUpdatePromise(idScheda, ap, "newValue",editorAnnoPrecedente,true);
          } catch (err) {
            console.error("Errore nel salvataggio", err);
          }

        setOpenImporto(false);
      }
    }
    //IMPORTO PROPOSTO
 
// ─── DATI DI ESEMPIO ─────────────────────────────────────────────────────────






    

const transformFattoriChiave = (fattoriChiave) => {
    let uno= false; let due= false; let tre= false;
    let quattro= false; let cinque= false; let sei= false;
    let sette= false; let otto= false; let nove= false;
    let dieci= false; let undici= false; let dodici= false;
    //console.log("vediamo",fattoriChiave);
    if(fattoriChiave["Attivazione dell'ascensore sociale: educazione, formazione e cultura"]==true )
        quattro=true;
    if(fattoriChiave["Attrazione di investimenti e talenti"]==true )
        nove=true;
    if(fattoriChiave["Connessione e riequilibrio tra centri e periferie"]==true )
        cinque=true;
    if(fattoriChiave["Costruzione di cittadinanza, democrazia e diritti"]==true )
        sei=true;
    if(fattoriChiave["Divario tecnologico e digitale"]==true )
        dodici=true;
    if(fattoriChiave["Innovazione di prodotto, di servizio e di processo nelle organizzazioni"]==true )
        dieci=true;
    if(fattoriChiave["Opportunità per bambini, giovani, famiglie e persone in condizioni di fragilità"]==true )
        tre=true;
    if(fattoriChiave["Sostenibilità di luoghi e istituzioni nel post PNRR"]==true )
        sette=true;
    if(fattoriChiave["Supporto al sistema del Welfare"]==true )
        uno=true;
    if(fattoriChiave["Sviluppo, rafforzamento e attrazione di competenze"]==true )
        due=true;
    if(fattoriChiave["Transizioni verde ed energetica"]==true )
        undici=true;
    if(fattoriChiave["Valorizzazione degli asset dei territori"]==true )
        otto=true;


    let a= [
        {
          icone: [{ key: "cuore" }, { key: "ingranaggio" }, { key: "persone" }],
          voci: [
            { testo: "Supporto al sistema del Welfare: istruzione, salute e benessere",                 attiva: uno }, // X
            { testo: "Sviluppo, rafforzamento e attrazione di competenze",                               attiva: due },
            { testo: "Opportunità per bambini, giovani, famiglie e persone in condizioni di fragilità", attiva: tre },          
          ],
        },
        {
          icone: [{ key: "documento" }, { key: "pin" }, { key: "sedia" }],
          voci: [
            { testo: "Riattivazione dell'ascensore sociale: educazione, formazione e cultura",           attiva: quattro }, // X
            { testo: "Connessione e riequilibrio tra centri e periferie",    attiva: cinque },
            { testo: "Costruzione di cittadinanza, democrazia e diritti",    attiva: sei },          
          ],
        },
        {
          icone: [{ key: "colonne" }, { key: "fulmine" }, { key: "lampadina" }],
          voci: [
            { testo: "Sostenibilità di luoghi e istituzioni nel post PNRR", attiva: sette },
            { testo: "Valorizzazione degli asset dei territori",                                 attiva: otto },
            { testo: "Attrazione di investimenti e talenti",                                     attiva: nove },          
          ],
        },
        {
          icone: [{ key: "ricerca" }, { key: "foglia" }, { key: "digitale" }],
          voci: [
            { testo: "Innovazione di prodotto, di servizio e di processo nelle organizzazioni", attiva: dieci },
            { testo: "Transizioni verde ed energetica", attiva: undici },
            { testo: "Divario tecnologico e digitale",  attiva: dodici },
          ],
        },
      ];
      //console.log("vediamo uscita", a);
      return a;

}

const transformTrasversalitaMetodologica = (valore) => {
    let uno= false; let due= false; let tre= false; let quattro= false;    
    
    if(valore["Mobilisation & partnership"]==true )
        uno=true;
    if(valore["Learning"]==true )
        due=true;
    if(valore["Advocacy"]==true )
        tre=true;
    if(valore["Internationalization"]==true )
        quattro=true;
        
    let a=[
        { key: "handshake", label: "Mobilisation & Partnership", attiva: uno },
        { key: "libro",     label: "Learning",                   attiva: due },
        { key: "megafono",  label: "Advocacy",                   attiva: tre },
        { key: "globo",     label: "Internationalization",       attiva: quattro },
      ];    
      
    return a;
}

const transformConcettiChiave = (valore) => {
    let uno= false; let due= false; let tre= false; let quattro= false;
    
    if(valore["Fiducia"]==true )
        uno=true;
    if(valore["Flessibilità"]==true ||valore["Flessibilita"]==true||valore["Flessibilit\u00e0"]==true  )
        due=true;

    if(valore["Rischio"]==1 ) //MEDIO
        tre=true; 
    if(valore["Rischio"]==2 ) //ALTO
        quattro=true;
       
    if(uno && due && tre) //MEDIO
        return "fiducia-flessibilita-rischiomedio";
    if(uno && due && quattro) //ALTO
        return "fiducia-flessibilita-rischioalto";    
    if(uno && due && !tre && !quattro)
        return "fiducia-flessibilita";

    if(uno && !due && tre && !quattro)
        return "fiducia-rischiomedio";
    if(uno && !due && !tre && quattro)
        return "fiducia-rischioalto";

    if(uno && !due && !tre && !quattro)
        return "fiducia";

    if(!uno && due && tre && !quattro)
        return "flessibilita-rischiomedio";
    if(!uno && due && !tre && quattro)
        return "flessibilita-rischioalto";

    if(!uno && due && !tre && !quattro)
        return "flessibilita";    

    if(!uno && !due && tre && !quattro)
        return "rischiomedio";    
    if(!uno && !due && tre && quattro)
        return "rischioalto";        

    return "nessuno";
}

const transformAllineamenti = (valore) => {
    let uno= false; let due= false; let tre= false;    
    
    if(valore["Italia"]==true )
        uno=true;
    if(valore["Europa"]==true )
        due=true;
    if(valore["Mondo"]==true )
        tre=true;
   
    if(uno && due && tre)
        return "mondo-europa-italia";
    if(uno && !due && !tre)
        return "italia";
    if(!uno && due && !tre)
        return "europa";
    if(!uno && !due && tre)
        return "mondo";

    if(uno && due && !tre)
        return "europa-italia";
    if(uno && !due && tre)
        return "mondo-italia";   
    if(!uno && due && tre)
        return "mondo-europa";    
    return "nessuno";
}

const transformPrioritaTematica = (valore) => {
    //console.log("PRIORITA TEMATICA", valore);
    let uno= false; let due= false; ;
    if(Array.isArray(valore)){
        if(valore["Sviluppo territoriale sostenibile"]==true||valore["Sviluppo territoriale sostenibile "]==true )
            uno=true;
        if(valore["Riduzione delle disuguaglianze"]==true||valore["Riduzione delle disuguaglianze "]==true)               
            due=true;
    }
    else{
        if(valore.trim()=="Sviluppo territoriale sostenibile")
            uno=true;
        if(valore.trim()=="Riduzione delle disuguaglianze")
            due=true;
    }

    if(uno && !due)
        return "sviluppo_sostenibile";
    if(!uno && due)
        return "riduzione_disuguaglianze";

    return "nessuno";
}

const transformVelocitaAndProgettiImpatto = (valore, valore2) => {
    //console.log("VELOCITA",valore, valore2);
    let uno= false; let due= false; let tre= false;
    let progetto="";
    //if(valore=="Progetti a impatto")
    if(valore=="Progetti a impatto" ||valore=="Progetti di  sviluppo" )
        uno=true;
    if(valore=="Tenuta del sistema")
        due=true;
    if(valore=="Cambiamento sistemico")
        tre=true;

    if(uno==true){
        if(valore2!=undefined)
            progetto=valore2;
        else
            progetto="Arcate MOI";    
    }
    //if (progetto!='')
    let a=[    
            { key: "progetti-impatto",      attiva: uno , progetto: progetto },
            { key: "cambiamento-sistemico",  attiva: tre},
            { key: "tenuta-sistema",         attiva: due},    
    ];

    return a;
}

const transformAttributiProgetto = (valore) => {
    //console.log("ATTRIBUTI",valore);
    let uno= false; let due= false; let tre= false;
   
    if(valore["Prevede attività di capacity building/organizational development"]==true )
        uno=true;
    if(valore["Emergenza"]==true )
        due=true;
    if(valore["Altro/Nessuno"]==true )
        tre=true;

    let a =[
        { key: "casa",   label: "Emergenza",                                      attiva: due },
        { key: "puzzle", label: "Capacity building / Organizational development", attiva: uno  },
        { key: "lista",  label: "Altro",                                          attiva: tre },
      ]

    return a;
}

const transformTrasversalita = (valore) => {
    //console.log("TRASVERSALITA'",valore);
    let uno= false; let due= false; let tre= false; let quattro=false;
   
    if(valore["Education"]==true )
        uno=true;
    if(valore["Innovation"]==true )
        due=true;
    if(valore["Participation"]==true )
        tre=true;
    if(valore["Internationalization"]==true )
        quattro=true;

    let a =[
        { key: "cappello", label: "Education",             attiva: uno },
        { key: "razzo",    label: "Innovation",            attiva: due  },
        { key: "mani",     label: "Participation",         attiva: tre },
        { key: "globo",    label: "Internationalization",  attiva: quattro },
    ];

    return a;
}

const transformStretegia = (valore) => {
    //console.log("STRATEGIA'",valore);
    const strategia = valore
    .map(id => {
    const item = strategiaMap[id];
    if (!item) return null;

    return {
      ...item,
      attiva: true,
      colore: strategiaMap[id].colore,
    };
    }).filter(Boolean);
    return strategia;
    
}

const transformMissioniSingle = (valore) => {
    console.log("MISSIONI SINGLE'",valore);

    if(Array.isArray(valore))
        valore= valore[0].toLowerCase();
    else
        valore= valore.toLowerCase();
    
    //console.log("MISSIONI SINGLE'",valore);
   
    if (valore=='abitare'||valore=='lavoro'||valore=='educazione'||valore=='comunità'||valore=='inclusione'||
        valore=='abitare tra casa e territorio'||valore=='favorire il lavoro dignitoso'||valore=='educare per crescere insieme'||valore=='diventare comunità'||valore=="collaborare per l'inclusione"||valore=='collaborare per l’inclusione'){        
        let a= [
            { numero: 5, testo: "Abitare tra casa e territorio",                 obiettivo:"persone",  attiva: valore=='abitare'||valore=='abitare tra casa e territorio' },
             { numero: 6, testo: "Favorire il lavoro dignitoso",                  obiettivo:"persone", attiva: valore=='lavoro'||valore=='favorire il lavoro dignitoso' },
             { numero: 7, testo: "Educare per crescere insieme",                  obiettivo:"persone", attiva: valore=='educazione'||valore=='educare per crescere insieme' },
             { numero: 8, testo: "Diventare comunità",                            obiettivo:"persone", attiva: valore=='comunità' ||valore=='diventare comunità'},  
             { numero: 9, testo: "Collaborare per l'inclusione",                  obiettivo:"persone", attiva: valore=='inclusione'||valore=="collaborare per l'inclusione"||valore=='collaborare per l’inclusione'},
        ];
        return a;
    }
    if(valore=='attrattività'||valore=='competenze'||valore=='custodia'||valore=='partecipazione'||
        valore=='creare attrattività'||valore=='sviluppare competenze'||valore=='custodire la bellezza'||valore=='favorire partecipazione attiva'||valore=='favorire la partecipazione attiva'){
        let a= [
            { numero: 1, testo: "Creare attrattività",                           obiettivo:"cultura", attiva: valore=='attrattività'|| valore=='creare attrattività'},
            { numero: 2, testo: "Sviluppare competenze",                         obiettivo:"cultura", attiva: valore=='competenze'|| valore=='sviluppare competenze' },
            { numero: 3, testo: "Custodire la bellezza",                         obiettivo:"cultura", attiva: valore=='custodia'|| valore=='custodire la bellezza'},
            { numero: 4, testo: "Favorire partecipazione attiva",                obiettivo:"cultura", attiva: valore=='partecipazione'|| valore=='favorire partecipazione attiva'|| valore=='favorire la partecipazione attiva' },  
       ];
       return a;
    }
    if(valore=='ricerca'||valore=='innovazione'||valore=='benessere'||valore=='sviluppo territorio'||valore=='ambiente'||
        valore=='valorizzare la ricerca'||valore=="accelerare l'innovazione"||valore=='promuovere il benessere'||valore=='sviluppare il territorio in modo sostenibile'||valore=='sviluppare il territorio'||valore=="proteggere l'ambiente"||valore=='proteggere l’ambiente'||valore=='accelerare l’innovazione'){
        let a= [
            { numero: 10, testo: "Valorizzare la ricerca",                       obiettivo:"pianeta", attiva: valore=='ricerca'|| valore=='valorizzare la ricerca' },
            { numero: 11, testo: "Accelerare l'innovazione",                     obiettivo:"pianeta", attiva: valore=='innovazione'|| valore=="accelerare l'innovazione"||valore=='accelerare l’innovazione'},
            { numero: 12, testo: "Promuovere il benessere",                      obiettivo:"pianeta", attiva: valore=='benessere'|| valore=='promuovere il benessere'},
            { numero: 13, testo: "Sviluppare il territorio in modo sostenibile", obiettivo:"pianeta", attiva: valore=='sviluppo territorio'||valore=='sviluppare il territorio'|| valore=='sviluppare il territorio in modo sostenibile'},
            { numero: 14, testo: "Proteggere l'ambiente",                        obiettivo:"pianeta", attiva: valore=='ambiente' || valore=="proteggere l'ambiente"||valore=='proteggere l’ambiente'},  
       ];
       return a;
    }
    if(valore=='Internazionalizzazione'||valore=='aprire scenari internazionali'){
        let a= [
            { numero: 10, testo: "Valorizzare la ricerca",                       obiettivo:"pianeta", attiva: false  },
            { numero: 11, testo: "Accelerare l'innovazione",                     obiettivo:"pianeta", attiva: false },
            { numero: 12, testo: "Promuovere il benessere",                      obiettivo:"pianeta", attiva: false },
            { numero: 13, testo: "Aprire scenari internazionali",                obiettivo:"pianeta", attiva: true },
            { numero: 14, testo: "Proteggere l'ambiente",                        obiettivo:"pianeta", attiva: false },  
       ];
       return a;
    }
    //TODO: DA GESTIRE CASI VECCHI SETTORI E DIREZIONE
}

const getObiettivoFromMissioneSingle = (valore) => {
    console.log("MISSIONI'",valore);
    if(Array.isArray(valore))
        valore= valore[0].toLowerCase();
    else
        valore= valore.toLowerCase();

    //if (valore=='Abitare'||valore=='Lavoro'||valore=='Educazione'||valore=='Comunità'||valore=='Inclusione'){                
    if (valore=='abitare'||valore=='lavoro'||valore=='educazione'||valore=='comunità'||valore=='inclusione'||
        valore=='abitare tra casa e territorio'||valore=='favorire il lavoro dignitoso'||valore=='educare per crescere insieme'||valore=='diventare comunità'||valore=="collaborare per l'inclusione"||valore=='collaborare per l’inclusione'){  
        return "persone";
    }
    //if(valore=='Attrattività'||valore=='Competenze'||valore=='Custodia'||valore=='Partecipazione'){        
    if(valore=='attrattività'||valore=='competenze'||valore=='custodia'||valore=='partecipazione'||
        valore=='creare attrattività'||valore=='sviluppare competenze'||valore=='custodire la bellezza'||valore=='favorire partecipazione attiva'|| valore=='favorire la partecipazione attiva'){
       return "cultura";
    }
    //if(valore=='Ricerca'||valore=='Innovazione'||valore=='Benessere'||valore=='Sviluppo territorio'||valore=='Ambiente'){        
    if(valore=='ricerca'||valore=='innovazione'||valore=='benessere'||valore=='sviluppo territorio'||valore=='ambiente'||
        valore=='valorizzare la ricerca'||valore=="accelerare l'innovazione"||valore=='promuovere il benessere'||valore=='sviluppare il territorio in modo sostenibile'||valore=='sviluppare il territorio'||valore=="proteggere l'ambiente"||valore=='proteggere l’ambiente'||valore=='accelerare l’innovazione'){
       return "pianeta";
    }
    //if(valore=='Internazionalizzazione'){        
    if(valore=='internazionalizzazione'||valore=='aprire scenari internazionali'){
       return "pianeta";
    }
}

const getMissioniFromMissioneMultiple = (valore) => {
    console.log("MISSIONISSIME'",valore.length);
    let cultura=0; 
    let pianeta=0; 
    let persone=0; 
    let altro=0;

    for (var i = 0; i < valore.length; i++) {
        if (valore[i]=='Abitare'||valore[i]=='Lavoro'||valore[i]=='Educazione'||valore[i]=='Comunità'||valore[i]=='Inclusione'||
            valore[i]=='Abitare tra casa e territorio'||valore[i]=='Favorire il lavoro dignitoso'||valore[i]=='Educare per crescere insieme'||valore[i]=='Diventare comunità'||valore[i]=="Collaborare per l'inclusione"){
            persone=persone+1;
        }
        else if(valore[i]=='Attrattività'||valore[i]=='Competenze'||valore[i]=='Custodia'||valore[i]=='Partecipazione'||
            valore[i]=='Creare attrattività'||valore[i]=='Sviluppare competenze'||valore[i]=='Custodire la bellezza'||valore[i]=='Favorire partecipazione attiva'){        
            cultura=cultura+1;
        }
        else if(valore[i]=='Ricerca'||valore[i]=='Innovazione'||valore[i]=='Benessere'||valore[i]=='Sviluppo territorio'||valore[i]=='Ambiente'||valore[i]=='Internazionalizzazione'||
            valore[i]=='Valorizzare la ricerca'||valore[i]=="Accelerare l'innovazione"||valore[i]=='Promuovere il benessere'||valore[i]=='Sviluppare il territorio in modo sostenibile'||valore[i]=="Proteggere l'ambiente"||valore[i]=='Aprire scenari internazionali'){        
            pianeta=pianeta+1;
        }
        else
            altro=altro +1;
    }
    if(persone >0 && cultura==0 && pianeta ==0 && altro ==0){
        let a= [
             { numero: 5, testo: "Abitare tra casa e territorio",                  obiettivo:"persone",  attiva: valore.includes('Abitare') },
             { numero: 6, testo: "Favorire il lavoro dignitoso",                  obiettivo:"persone", attiva: valore.includes('Lavoro') },
             { numero: 7, testo: "Educare per crescere insieme",                  obiettivo:"persone", attiva: valore.includes('Educazione') },
             { numero: 8, testo: "Diventare comunità",                            obiettivo:"persone", attiva: valore.includes('Comunità') },  
             { numero: 9, testo: "Collaborare per l'inclusione",                  obiettivo:"persone", attiva: valore.includes('Inclusione') },
        ];
        return a;
    }
        
    else if(persone ==0 && cultura>0 && pianeta ==0 && altro ==0){
        let a= [
            { numero: 1, testo: "Creare attrattività",                           obiettivo:"cultura", attiva: valore.includes('Attrattività') },
            { numero: 2, testo: "Sviluppare competenze",                         obiettivo:"cultura", attiva: valore.includes('Competenze') },
            { numero: 3, testo: "Custodire la bellezza",                         obiettivo:"cultura", attiva: valore.includes('Custodia') },
            { numero: 4, testo: "Favorire partecipazione attiva",                obiettivo:"cultura", attiva: valore.includes('Partecipazione') },  
       ];
       return a;
    }
        
    else if(persone ==0 && cultura==0 && pianeta >0 && altro ==0){
        let a= [
            { numero: 10, testo: "Valorizzare la ricerca",                       obiettivo:"pianeta", attiva: valore.includes('Ricerca')  },
            { numero: 11, testo: "Accelerare l'innovazione",                     obiettivo:"pianeta", attiva: valore.includes('Innovazione') },
            { numero: 12, testo: "Promuovere il benessere",                      obiettivo:"pianeta", attiva: valore.includes('Benessere') },
            { numero: 13, testo: "Sviluppare il territorio in modo sostenibile", obiettivo:"pianeta", attiva: valore.includes('Sviluppo territorio') },
            { numero: 14, testo: "Proteggere l'ambiente",                        obiettivo:"pianeta", attiva: valore.includes('Ambiente') },  
       ];
       return a;
    }
    else{
        let a=[];
        for (var i = 0; i < valore.length; i++) {
            if (valore[i]=='Abitare')
                a.push({ numero: '#', testo: "Abitare tra casa e territorio",                 obiettivo:"persone",  attiva: valore[i]=='Abitare' });            
            else if(valore[i]=='Lavoro')
                a.push({ numero: '#', testo: "Favorire il lavoro dignitoso",                  obiettivo:"persone", attiva: valore[i]=='Lavoro' });
            else if(valore[i]=='Educazione')            
                a.push({ numero: '#', testo: "Educare per crescere insieme",                  obiettivo:"persone", attiva: valore[i]=='Educazione' });
            else if(valore[i]=='Comunità')
                a.push({ numero: '#', testo: "Diventare comunità",                            obiettivo:"persone", attiva: valore[i]=='Comunità' }  );
            else if(valore[i]=='Inclusione')
                a.push({ numero: '#', testo: "Collaborare per l'inclusione",                  obiettivo:"persone", attiva: valore[i]=='Inclusione' });
            else if(valore[i]=='Attrattività')
                a.push({ numero: '#', testo: "Creare attrattività",                           obiettivo:"cultura", attiva: valore[i]=='Attrattività' });
            else if(valore[i]=='Competenze')
                a.push({ numero: '#', testo: "Sviluppare competenze",                         obiettivo:"cultura", attiva: valore[i]=='Competenze' });
            else if(valore[i]=='Custodia')
                a.push({ numero: '#', testo: "Custodire la bellezza",                         obiettivo:"cultura", attiva: valore[i]=='Custodia' });
            else if(valore[i]=='Partecipazione')
                a.push({ numero: '#', testo: "Favorire partecipazione attiva",                obiettivo:"cultura", attiva: valore[i]=='Partecipazione' });
            else if(valore[i]=='Ricerca')
                a.push({ numero: '#', testo: "Valorizzare la ricerca",                       obiettivo:"pianeta", attiva: valore[i]=='Ricerca'  });
            else if(valore[i]=='Innovazione')
                a.push({ numero: '#', testo: "Accelerare l'innovazione",                     obiettivo:"pianeta", attiva: valore[i]=='Innovazione' });
            else if(valore[i]=='Benessere')
                a.push({ numero: '#', testo: "Promuovere il benessere",                      obiettivo:"pianeta", attiva: valore[i]=='Benessere' });
            else if(valore[i]=='Sviluppo territorio')
                a.push({ numero: '#', testo: "Sviluppare il territorio in modo sostenibile", obiettivo:"pianeta", attiva: valore[i]=='Sviluppo territorio' });
            else if(valore[i]=='Ambiente')
                a.push({ numero: '#', testo: "Proteggere l'ambiente",                        obiettivo:"pianeta", attiva: valore[i]=='Ambiente' });
            else if(valore[i]=='Internazionalizzazione')        
                a.push({ numero: '#', testo: "Aprire scenari internazionali",                obiettivo:"pianeta", attiva: valore[i]=='Internazionalizzazione' });            
            else {
                //TODO GESTIRE DIREZIONE E SETTORI VECCHI
            }            
        }    
        return a;        
    }
}

const getObiettiviFromMissioneMultiple= (valore) => {
    console.log("OBIETTIVISSIMI'",valore.length);
    let cultura=0; 
    let pianeta=0; 
    let persone=0; 
    let altro=0;

    for (var i = 0; i < valore.length; i++) {
        //console.log("VALORE",valore[i]);
        if (valore[i]=='Abitare'||valore[i]=='Lavoro'||valore[i]=='Educazione'||valore[i]=='Comunità'||valore[i]=='Inclusione'){                
            persone=persone+1;
        }
        else if(valore[i]=='Attrattività'||valore[i]=='Competenze'||valore[i]=='Custodia'||valore[i]=='Partecipazione'){        
        cultura=cultura+1;
        }
        else if(valore[i]=='Ricerca'||valore[i]=='Innovazione'||valore[i]=='Benessere'||valore[i]=='Sviluppo territorio'||valore[i]=='Ambiente'||valore[i]=='Internazionalizzazione'){        
        pianeta=pianeta+1;
        }
        else
            altro=altro +1;
    }
    //console.log("COUNTERS",cultura,pianeta,persone,altro);
    if(persone >0 && cultura==0 && pianeta ==0 && altro ==0)
        return "persone";
    if(persone ==0 && cultura>0 && pianeta ==0 && altro ==0)
        return "cultura";
    if(persone ==0 && cultura==0 && pianeta >0 && altro ==0)
        return "pianeta";
    if(persone >0 && cultura>0 && pianeta ==0 && altro ==0)
        return ["persone", "cultura"];
    if(persone >0 && cultura==0 && pianeta >0 && altro ==0)
        return ["persone", "pianeta"];        
    if(persone ==0 && cultura>0 && pianeta >0 && altro ==0)
        return [ "cultura", "pianeta"];
    if(persone >0 && cultura>0 && pianeta >0 && altro ==0)
        return [ "persone", "cultura", "pianeta"];
     //TODO: gestire il caso vecchi settori e direzioni  
}


const findValue = (entries,label) =>
    entries.find(e => e.label === label)?.value ?? null;


const isZero = (str) => {
    if (str == null) return true;
    const normalized = String(str).trim().replace(",", ".");
    return parseFloat(normalized) === 0 || normalized === "";
};

const handleOpenSlide = async (val,dataSeduta,fase,idScheda, home) => {
        //let v=val.value;          
        console.log("POROHOH1",val);
        //console.log("POROHOH2",dataSeduta, fase);
        //console.log("POROHOH3",idScheda);
        console.log("POROHOH4",home);
        //console.log("POROHOH5",localStorage.getItem("Missione_Indice"));
        let DATA_SLIDE = {            
            obiettivo: [],            
            missione: [],
            allineamento: "",           
            concettiAttivi: "",            
            prioritaAttiva:"",            
            velocitaVoci: [],
            fattoriChiave: [],
            trasversalitaMetodologiche: [],
            attributiProgetto: [],
            trasversalita: [],            
            strategia: [],
        };
        const dettagliEntry = home.find(e => e.label === "Dettagli Importo Proposto");
        const table = dettagliEntry?.table;
        const dataRows = table.filter(row => Array.isArray(row) && row[2] === "DATA");
        //console.log("ESGE",dataRows);
        // ── verifica se tutti gli importi sono zero ────────────────────────────────
        // considera sia colonna 4 (Anno In Corso) che colonna 5 (Anno Precedente)
        const allZero = dataRows.every(row => isZero(row[4]) && isZero(row[5]));
       
        if (allZero) {  //CASO MISSIONE SINGOLA LETTA DA MISSIONE E CULTURA
          //console.log("MISS",findValue(home,"Missione"));
          //console.log("OBIE",findValue(home,"Obiettivo"));
          DATA_SLIDE.obiettivo=[findValue(home,"Obiettivo").toLowerCase()];
          DATA_SLIDE.missione=transformMissioniSingle([findValue(home,"Missione").toLowerCase()]);    
        }
        else{ //CASO MISSIONI LETTE DA IMPORTO SPLITTATO -> DA GESTIRE CASO SINGOLO DA CASO MULTIPLO
            const missioni = dataRows
            .filter(row => !isZero(row[4]) || !isZero(row[5]))
            .map(row => String(row[3]).trim())
            .filter(Boolean);
            //console.log("MISSS",missioni);  
            //console.log("MISSS",missioni.length);  
            if( missioni.length==1){
                DATA_SLIDE.missione=transformMissioniSingle(missioni);             
                DATA_SLIDE.obiettivo=getObiettivoFromMissioneSingle(missioni);
            }
            else{
                //SEPARARE CASO DUE MISSIONI STESSO OBIETTIVO DA DUE MISSIONI OBIETTIVO DIVERSO                
                DATA_SLIDE.missione=getMissioniFromMissioneMultiple(missioni);   
                DATA_SLIDE.obiettivo=getObiettiviFromMissioneMultiple(missioni);
            }
        }
        ///DA GESTIRE ANCHE IL CASO IN CUI LA PRATICA SIA PRESENTE NEL BOX NEUTRO


        setDataSlide(null);
        setErrorSlide(null);
        setLoadingSlide(true);
        setOpenSlide(true);                         // apre subito → spinner visibile
      
      
       
        try {
            var xhr2 = new XMLHttpRequest();                      
            xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/getIndiceItem.php',true);
            xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
            xhr2.withCredentials = true;
            xhr2.onload = function (e) {      
                if (xhr2.readyState === 4) {
                    if (xhr2.status === 200) {                                          
                        console.log("OK92",xhr2);
                        var responseText = xhr2.responseText;                    
                        var obj=JSON.parse(responseText);
                        
                        //console.log("OK9893",obj, obj.ScelteDPP);    
                        //console.log("OK9893",obj, obj.ScelteDPP["1. Allineamenti"]);    
                        //console.log("OK379123",obj, obj.ScelteDPP["3. Trasversalità metodologica"]);    
                        //console.log("OK7777",obj, obj.ScelteDPP["5. Fattori Chiave"]["Attivazione dell'ascensore sociale: educazione, formazione e cultura"]);    
                        //transformFattoriChiave(obj.ScelteDPP["5. Fattori Chiave"]);
                        //DATA_SLIDE.obiettivo=["cultura"];

                        DATA_SLIDE.allineamento=transformAllineamenti(obj.ScelteDPP["1. Allineamenti"]);
                        DATA_SLIDE.concettiAttivi=transformConcettiChiave(obj.ScelteDPP["2. Concetti chiave"]);
                        DATA_SLIDE.trasversalitaMetodologiche=transformTrasversalitaMetodologica(obj.ScelteDPP["3. Trasversalità metodologica"]);
                        DATA_SLIDE.prioritaAttiva=transformPrioritaTematica(obj.ScelteDPP["4. Priorità Tematica prevalente"]);
                        DATA_SLIDE.fattoriChiave=transformFattoriChiave(obj.ScelteDPP["5. Fattori Chiave"]);
                        DATA_SLIDE.velocitaVoci=transformVelocitaAndProgettiImpatto(obj.ScelteDPP["6. Velocità d'intervento"],obj.ScelteDPP["100. Progetti a impatto"]);
                        DATA_SLIDE.attributiProgetto=transformAttributiProgetto(obj.ScelteDPP["7. Tipo/Attributi di progetto"]);
                        DATA_SLIDE.trasversalita=transformTrasversalita(obj.ScelteDPP["8. Trasversalità tematica"]);
                        DATA_SLIDE.strategia=transformStretegia(val);
                                        
                        //updateUI(jsonListIndici);   
                        //setLoading(false);      
                        setOpenedLabel(val.label);
                        setDataSlide(DATA_SLIDE);         
                        setLoadingSlide(false);                                       
                    } 
                    else {                    
                        console.log("Errore 9201: Recuperando indice in doPostSedute2");                      
                    }
                }
            };
        
            xhr2.onerror = function (e) {
                console.error("Error 2092", xhr2.statusText);
            };
            
            let urlEncodedData = null;                              
            urlEncodedData = "data=" + dataSeduta+"&fase="+fase+"&idPratica="+idScheda;                      
            console.log("DATA",urlEncodedData);                           
            xhr2.send(urlEncodedData);
            
          } catch (err) {
            console.error("handleOpenSlide:", err);
            setErrorSlide(err.message || "Errore nel caricamento");
          } finally {
            setLoadingSlide(false);
          }               
      };


      const handleCloseSlide = () => {    
        console.log("Close:", editorContent);    
        setCommentContent('');  
        setOpenedLabel(null)
        setOpenSlide(false);
      };
      
   
const handleSaveSlide = async () => {
    if (!schedaRef.current) return;
   
    let clone = null;
    let wrapper = null;
   
    try {
      const h2c = typeof html2canvas !== "undefined"
        ? html2canvas
        : (await import("html2canvas")).default;
   
      // ── 1. crea un container fuori schermo ──────────────────────────────────
      wrapper = document.createElement("div");
      Object.assign(wrapper.style, {
        position:   "fixed",
        top:        "0",
        left:       "-99999px",   // fuori dalla viewport, ma nel DOM → non scrollato
        width:      "auto",
        height:     "auto",
        overflow:   "visible",
        zIndex:     "-1",
        background: "#ffffff",
      });
      document.body.appendChild(wrapper);
   
      // ── 2. clona il nodo della scheda ───────────────────────────────────────
      clone = schedaRef.current.cloneNode(true);
      Object.assign(clone.style, {
        width:    schedaRef.current.scrollWidth  + "px",  // larghezza reale completa
        height:   schedaRef.current.scrollHeight + "px",  // altezza reale completa
        overflow: "visible",
        transform: "none",
      });
      wrapper.appendChild(clone);
   
      // ── 3. screenshot del clone (nessun clipping) ───────────────────────────
      const canvas = await h2c(clone, {
        scale:           2,
        useCORS:         true,
        backgroundColor: "#ffffff",
        logging:         false,
        // dimensioni esplicite = contenuto reale, non la finestra
        width:  schedaRef.current.scrollWidth,
        height: schedaRef.current.scrollHeight,
        windowWidth:  schedaRef.current.scrollWidth,
        windowHeight: schedaRef.current.scrollHeight,
      });
   
      // ── 4. download ─────────────────────────────────────────────────────────
      const link = document.createElement("a");
      link.download = `scheda_${Date.now()}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
   
    } catch (err) {
      console.error("Screenshot fallito:", err);
    } finally {
      // ── 5. pulizia ──────────────────────────────────────────────────────────
      if (wrapper && document.body.contains(wrapper)) {
        document.body.removeChild(wrapper);
      }
    }
  };

    const handleHide = (val) => {    
        if (!loading) { setLoading(true);}   
        console.log("HIDINIG",val);
        doPostUpdate (idScheda, val.originalField, "hide",false);  
        console.log("HIDE",val.originalField, idScheda);        
        };

    const handleOpen = (val) => {
      //let v=val.value;  
      console.log("HO",val);
      setOpenedLabel(val.label);
      let v = val.newValue || val.value;
      //let val2=v.replaceAll('</p>', '</p><p><br></p>')
      //  console.log("VAL",val2);
      setItemContent(val);
      //setEditorContent(val2 || '');
      setEditorContent(v || '');
      setCommentContent(val.comment||'');
      setOpen(true);
    };
  
    const handleClose = () => {    
        console.log("Close:", editorContent);    
        setCommentContent('');  
        setOpenedLabel(null)
        setOpen(false);
      };
  
    //const handleSave = () => {
    const handleSave = async () => {   
      if (!loading) { setLoading(true);}   
      //doPostUpdate (idScheda, itemContent.originalField, "newValue",editorContent);        
      //doPostUpdate (idScheda, itemContent.originalField, "comment",commentContent);  

      try {
        await doPostUpdatePromise(idScheda, itemContent.originalField, "newValue",editorContent, false);    
        await doPostUpdatePromise(idScheda, itemContent.originalField, "comment",commentContent,true);                          
      } catch (err) {
        console.error("Errore nel salvataggio", err);
      }
      
        setCommentContent('');
        setOpenedLabel(null);
      //}
      setOpen(false);
    };

//    const [color, setColor] = useState([]);

//    var dateStyle = {
//        display: "flex",
//        paddingLeft: "25px",
//    };
//    const id=idScheda;

    const onClickToUpdate= (e ) => {   
        navigate("/schede/"+ idScheda);
    };

    const updateUI = function(jsonData) {
        const keyValuScores = jsonData;
        const homeFieldsItem = Object.entries(keyValuScores.components.home.fields);
        //if( properties.verboseLog==1)
            //console.log("HFI",homeFieldsItem);
        const indexFieldsItem = Object.entries(keyValuScores.index.fields);
        //console.log("IFI",indexFieldsItem);
        var homeItems = [];
        var relazioneItems = [];
        let obiettivo;
        for (var i = 0; i < homeFieldsItem.length; i++) {
            var firstItemCss = "0px";
            var itemBorderColor = "";
            //console.log("WWWWWWW",    homeFieldsItem[i][0]);
            if (i === 0) {
                firstItemCss = "8px";
            }
            if (
                homeFieldsItem[i][1]["componentRef"] ||
                (homeFieldsItem[i][1]["style"] === 0 &&
                    !homeFieldsItem[i][1]["secondValue"] &&
                    !homeFieldsItem[i][1]["comment"])
            ) {
                itemBorderColor = "1px solid #EFEFEF";
            }
            if( properties.verboseLog==1){
                console.log("home", homeFieldsItem[i]);
                console.log("home1",keyValuScores);
            }

            if (homeFieldsItem[i][1]["label"]==="Obiettivo") {
                obiettivo = homeFieldsItem[i][1]["value"];
            }
            var item = {
                componentRef: homeFieldsItem[i][1]["componentRef"],
                label: homeFieldsItem[i][1]["label"],
                value: homeFieldsItem[i][1]["value"],
                style: homeFieldsItem[i][1]["style"],
                second: homeFieldsItem[i][1]["secondValue"],
                comment: homeFieldsItem[i][1]["comment"],
                table: homeFieldsItem[i][1]["table"],
                originalField:homeFieldsItem[i][0],
                newValue:homeFieldsItem[i][1]["newValue"],
                hide:homeFieldsItem[i][1]["hide"],
                itemcss: firstItemCss,
                bordercss: itemBorderColor,
            };
            if(item.table){
                //console.log("EECCE",item.table);
                //item.table.shift();
                const table = typeof item.table === "string"? JSON.parse(item.table): item.table;                
                table.shift();
            }
            homeItems.push(item);
        }   
        //console.log("SSSW1",keyValuScores);
        const allegatiFieldsItem = Object.entries(keyValuScores.components.allegati);
        console.log("SSSW2",allegatiFieldsItem);
        
        var firstItemCss = "0px";
        var itemBorderColor = "";
        for (var i = 0; i < allegatiFieldsItem.length; i++) {
                //console.log("TESE", allegatiFieldsItem[i][1], allegatiFieldsItem[i][1]["data_modifica"]);
                if (allegatiFieldsItem[i][1]["data_modifica"]!= undefined){ 
                //console.log("VER",allegatiFieldsItem[i][1]);
                var item = {
                    componentRef: allegatiFieldsItem[i][1]["componentRef"],
                    label: allegatiFieldsItem[i][1]["label_file"],
                    value: allegatiFieldsItem[i][1]["nome_file"],
                    sezione: allegatiFieldsItem[i][1]["sezione"],
                    posizione: allegatiFieldsItem[i][1]["posizione"],
                    style: allegatiFieldsItem[i][1]["style"],
                    tipo: "allegato",
                    key:allegatiFieldsItem[i][0],
                    data_modifica: allegatiFieldsItem[i][1]["data_modifica"],
                    dimensione: allegatiFieldsItem[i][1]["dimensione"],
                    //second: allegatiFieldsItem[i][1]["secondValue"],
                    //comment: allegatiFieldsItem[i][1]["comment"],
                    //table: allegatiFieldsItem[i][1]["table"],
                    //originalField:allegatiFieldsItem[i][0],
                    //newValue:allegatiFieldsItem[i][1]["newValue"],
                    //hide: allegatiFieldsItem[i][1]["hide"],
                    itemcss: firstItemCss,
                    bordercss: itemBorderColor,
                };
                homeItems.push(item);
            }
        }

        const appoggioFieldsItem = Object.entries(keyValuScores.components.appoggio.fields);
        console.log("PDPM",appoggioFieldsItem);
        for (var i = 0; i < appoggioFieldsItem.length; i++) {            
            if(appoggioFieldsItem[i][1]["label"]=="Importo Anno In Corso"||appoggioFieldsItem[i][1]["label"]=="Importo Anno Precedente" ||appoggioFieldsItem[i][1]["label"]=="Dettagli Importo Proposto"||appoggioFieldsItem[i][1]["label"]=="Importo Proposto"){
                    var firstItemCss = "0px";
                    var itemBorderColor = "";
                    if (
                        appoggioFieldsItem[i][1]["componentRef"] ||
                        (appoggioFieldsItem[i][1]["style"] === 0 &&
                            !appoggioFieldsItem[i][1]["secondValue"] &&
                            !appoggioFieldsItem[i][1]["comment"])
                    ) {
                        itemBorderColor = "1px solid #EFEFEF";
                    }
                    

                    if (appoggioFieldsItem[i][1]["label"]==="Obiettivo") {
                        obiettivo = appoggioFieldsItem[i][1]["value"];
                    }
                    var item = {
                        componentRef: appoggioFieldsItem[i][1]["componentRef"],
                        label: appoggioFieldsItem[i][1]["label"],
                        value: appoggioFieldsItem[i][1]["value"],
                        style: appoggioFieldsItem[i][1]["style"],
                        second: appoggioFieldsItem[i][1]["secondValue"],
                        comment: appoggioFieldsItem[i][1]["comment"],
                        table: appoggioFieldsItem[i][1]["table"],
                        originalField:appoggioFieldsItem[i][0],
                        newValue:appoggioFieldsItem[i][1]["newValue"],
                        hide:appoggioFieldsItem[i][1]["hide"],
                        itemcss: firstItemCss,
                        bordercss: itemBorderColor,
                    };
                    if(item.table){
                     //   item.table.shift();
                     //console.log("EECCE",item.table);
                     //item.table.shift();
                     if(typeof item.table === "string")
                        item.table=JSON.parse(item.table);
                     //const table = typeof item.table === "string"? JSON.parse(item.table): item.table;                
                     //item.table.shift();
                    }
                    homeItems.push(item);
                }
                if(appoggioFieldsItem[i][1]["label"]=="Ultima modifica"){            
                    //console.log("WWW",appoggioFieldsItem[i][1]);
                    const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                    console.log("UM",valZ);
                    if(valZ=='None')
                        setPraticaUltimaModifica("");
                    else
                        setPraticaUltimaModifica(valZ);
                    //setPraticaUltimaModificaOriginalField(appoggioFieldsItem[i][0]);
                }    
                if(appoggioFieldsItem[i][1]["label"]=="Modificato da"){                    
                    const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                    console.log("MD",valZ,appoggioFieldsItem);
                    if(valZ=='None')
                        setPraticaModificataDa("");
                    else
                        setPraticaModificataDa(valZ);
                    //setPraticaModificataDaOriginalField(appoggioFieldsItem[i][0]);
                }    
                if(appoggioFieldsItem[i][1]["label"]=="Bloccato"){                    
                    const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                    console.log("BL",valZ);
                    if(valZ=='false')
                        setPraticaBloccata(false);
                    else
                        setPraticaBloccata(true); 
                    setPraticaBloccataOriginalField(appoggioFieldsItem[i][0]);                                       
                }  
                if(appoggioFieldsItem[i][1]["label"]=="Altre Sedute"){                    
                    const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                    console.log("ALTRE",valZ);
                    if(valZ=='')
                        setSedutePrecedenti("");
                    else
                        setSedutePrecedenti(valZ);                     
                }  
                if(appoggioFieldsItem[i][1]["label"]=="Elementi di Strategia"){    
                    console.log("ER",appoggioFieldsItem[i][1]);                
                    const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                    console.log("E D S:",valZ);
                    if(valZ=='' || valZ=='None')
                        setElementiStrategia("");
                    else
                        setElementiStrategia(valZ);                     
                }    
            }
        
        const relazioneFieldsItem = Object.entries(keyValuScores.components.relazioneannotazioni.fields);
        for (var i = 0; i < relazioneFieldsItem.length; i++) {
            if(relazioneFieldsItem[i][1]["label"]=="Relazione/Annotazioni"){
                    var firstItemCss = "0px";
                    var itemBorderColor = "";
                    if (
                        relazioneFieldsItem[i][1]["componentRef"] ||
                        (relazioneFieldsItem[i][1]["style"] === 0 &&
                            !relazioneFieldsItem[i][1]["secondValue"] &&
                            !relazioneFieldsItem[i][1]["comment"])
                    ) {
                        itemBorderColor = "1px solid #EFEFEF";
                    }
                                     
                    var item = {
                        componentRef: relazioneFieldsItem[i][1]["componentRef"],
                        label: relazioneFieldsItem[i][1]["label"],
                        value: relazioneFieldsItem[i][1]["value"],
                        style: relazioneFieldsItem[i][1]["style"],
                        second: relazioneFieldsItem[i][1]["secondValue"],
                        comment: relazioneFieldsItem[i][1]["comment"],
                        table: relazioneFieldsItem[i][1]["table"],
                        originalField:relazioneFieldsItem[i][0],
                        newValue:relazioneFieldsItem[i][1]["newValue"],
                        hide:relazioneFieldsItem[i][1]["hide"],
                        itemcss: firstItemCss,
                        bordercss: itemBorderColor,
                    };
                    //if(item.table){
                     //   item.table.shift();
                    // console.log("EECCE",item.table);
                     //item.table.shift();
                    // if(typeof item.table === "string")
                    //    item.table=JSON.parse(item.table);
                     //const table = typeof item.table === "string"? JSON.parse(item.table): item.table;                
                     //item.table.shift();
                    //}
                    relazioneItems.push(item);
                }
            }
        


        console.log("HOME",homeItems);     
        console.log("REL",relazioneItems);     
        setHomeData(homeItems);
        setRelazioneData(relazioneItems)
             
        var keyExist = keyValuScores.hasOwnProperty("scoreboard");
        if (keyExist) {
            setScore(keyValuScores.scoreboard.score1Level);
        }  
        setLoading(false);
    }

    const doPostGenerateGSFCard = function(idScheda, dataSeduta, faseSeduta) {  
        setLoading(true);   
        var xhr = new XMLHttpRequest();        
        
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/generateGSFPratica.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  
        xhr.onload = function (e) {      
              if (xhr.readyState === 4) {
                  if (xhr.status === 200) {                             
                      //console.log("OK92",xhr);
                      var responseText = xhr.responseText;                    
                      console.log("OK92",responseText);
                      //
                      var obj=JSON.parse(responseText);
                      console.log("id1",obj.idScheda);
                      console.log("id2",obj.dataSeduta);
                      console.log("id3",obj.faseSeduta);
                      
                      //if( properties.verboseLog==1)
                      //  console.log("OK193",obj,responseText);   
                      setLoading(false);     
                      //const SchedaInfo = JSON.parse(obj.content);
                      //console.log("SI",SchedaInfo);                
                      //updateUI(SchedaInfo);
                      //navigate("/schede2/"+obj.dataSeduta+"/"+obj.faseSeduta+"/"+obj.idScheda);       
                      doPostSeduta2();
                }
                  else {                                
                      //alert("Errore recuperando i dati dell'indice");
                      setAlert(
                        <SweetAlert
                        warning
                        closeOnClickOutside ={true}
                        showCancel ={false}
                        showConfirm={false}
                        style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                        title={"Si è verificato un errore generando la scheda per il Fascicolo di Comitato. Controllare il numero di pratica inserito e riprovare"}
                        onConfirm={() => {
                            setAlert(null);                            
                        }}           
                        onCancel={() => {
                            setAlert(null);                          
                        }}
                      >
                      </SweetAlert>
                      );  
                      setLoading(false);  
                      //navigate("/indice/init",{ replace: true });                                    
                  }
              }
          };
  
          xhr.onerror = function (e) {
              console.error("Error 2", xhr.statusText);
          };
                        
          let urlEncodedData = "data=" + dataSeduta+ "&fase="+faseSeduta+"&idScheda="+idScheda;
          //if( properties.verboseLog==1)
          console.log("WERE",urlEncodedData);
          xhr.send(urlEncodedData);  
      }
  
      function formatDateISO(date) {
        const day = date.substring(0, 2);
        const month = date.substring(2, 4);
        const year = date.substring(4, 8);
        return `${year}-${month}-${day}`;
      }


    const doPostSeduta2 = function() {
    
        var xhr2 = new XMLHttpRequest();                        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/checkSchedaPreview.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                        console.log("OK93",obj);          
                    if(obj.status==="201" ){                         
                        console.log("OK CARD 201",xhr2);                                  
                        const SchedaInfo = JSON.parse(obj.content);
                        console.log("SI",SchedaInfo);                
                        updateUI(SchedaInfo);
                    }                   
                } 
                else {
                    console.error("Error 1", xhr2.statusText);          
                    //window.alert("Errore recuperando la scheda 1");    
                    setLoading(true);      
                    //doPostGenerateGSFCard(idScheda,dataSeduta,faseSeduta);
                    //navigate("/editor",{ replace: true });                      
                    doPostGenerateGSFCard(idScheda,formatDateISO(dataSeduta),faseSeduta);
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };
    
        let urlEncodedData = "ids=" + idScheda+ "&data="+dataSeduta+ "&fase="+faseSeduta;        
        xhr2.send(urlEncodedData);
    }
    
    const doPostUpdate = function(idScheda, entry, attribute, value) {
    
        var xhr2 = new XMLHttpRequest();                        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/updateSchedaPreview.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                        console.log("OK93",obj);          
                    if(obj.status==="201" ){                         
                        console.log("OK CARD 201",xhr2);                                      
                        const SchedaInfo = JSON.parse(obj.content);
                        updateUI(SchedaInfo);
                        
                    }
                } 
                else {
                    //console.error("Error 1", xhr.statusText);          
                    window.alert("Errore recuperando la scheda 1");                      
                    navigate("/editor",{ replace: true });                      
                }
            }
        };
        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };       
        let encValue= btoa(unescape(encodeURIComponent(value)))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
        
        //console.log("IDDIIO", value, encValue);  
        
        let urlEncodedData = "ids=" + idScheda + "&data="+dataSeduta+ "&fase="+faseSeduta+ "&key="+entry+"&attribute="+attribute+"&value="+encodeURIComponent(encValue);
        console.log(urlEncodedData);      
        xhr2.send(urlEncodedData);
    }



    const doPostUpdatePromise = function(idScheda, entry, attribute, value, update) {
        return new Promise((resolve, reject) => {
            var xhr2 = new XMLHttpRequest();
            xhr2.open( "POST", properties.productionUrl +properties.productionUrlSuffix +"/core/rest/updateSchedaPreview.php",true);        
            xhr2.withCredentials = true;
            xhr2.setRequestHeader("Content-type","application/x-www-form-urlencoded");
        
            xhr2.onload = function () {
              if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {
                  try {
                    const obj = JSON.parse(xhr2.responseText);        
                    if (obj.status === "201") {
                      const SchedaInfo = JSON.parse(obj.content);                                            
                      resolve(obj); 
                      if(update)
                      updateUI(SchedaInfo);  
                    } else {
                      window.alert("Errore recuperando la scheda 1");                      
                      reject(obj);
                    }
                  } catch (err) {
                    reject(err);
                  }
                } else {
                  reject(new Error("HTTP error " + xhr2.status));
                }
              }
            };
        
            xhr2.onerror = function () {
              reject(new Error("Network error"));
            };
        
            let encValue= btoa(unescape(encodeURIComponent(value)))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
                        
        let urlEncodedData = "ids=" + idScheda + "&data="+dataSeduta+ "&fase="+faseSeduta+ "&key="+entry+"&attribute="+attribute+"&value="+encodeURIComponent(encValue);
        console.log(urlEncodedData);              
        xhr2.send(urlEncodedData);
        });
    }

    const onFileChange2= (e ) => {   
        console.log("ew2",e); 
        
            
        if (!loading) { setLoading(true);} 
        e.stopPropagation();                     
        let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/rest/caricaAllegato.php";   
        let file=e.target.files[0];
        var bodyFormData=new FormData();
        if( properties.verboseLog==1)
            console.log("cire",file);
        bodyFormData.append('UploadedFile', file);
        bodyFormData.append('fileName', file.name);
        bodyFormData.append('id_scheda', idScheda);
        bodyFormData.append('data', dataSeduta);
        bodyFormData.append('fase', faseSeduta);
        axios({
            method: 'post',
            url: endpoint,
            data: bodyFormData, 
            withCredentials: true, 
            headers: {'Content-Type': 'multipart/form-data' }
        })
        .then(function (response) {                    
            setLoading(false);
            //if( properties.verboseLog==1)
            console.log("EEEEEEEEEEEEHHHHHH",response, file.name, itemContent.originalField);
            //doPostUpdate (idScheda, "allegati", "allegato",file.name);
            doPostUpdate (idScheda, "allegati", "allegato",response.data.fileName);
            doPostSeduta2();
            //allegatiRef.current?.scrollIntoView({ behavior: "smooth" });
            //console.log("EEEEEEEEEEEEHHHHHH",response, file.name, itemContent.originalField);
        })
        .catch(function (response) {            
            console.log("ERRORE1",response);
        });
        
    };


    useEffect(() => {                      
        updateSeduta(dataSeduta,doPostSeduta2,updateUI);        
    }, []);
    
    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 10,
        borderRadius: 5,
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 300 : 700], 
        '& .MuiLinearProgress-bar': {
          borderRadius: 5,
          backgroundColor: '#5cb85c',
        },
      }));

    const openScoreBoard = (id) => {
        navigate("/schede/"+ idScheda + "/scoreboard");  
    };

    const goFinalInfo = (refname) => {
        if( properties.verboseLog==1)
            console.log("called goFinalInfo");
        if (refname) {            
            //navigate("/schede2/"+ idScheda + "/" + refname);  
            navigate("/schede2/"+dataSeduta+"/"+faseSeduta+"/"+idScheda+ "/" + refname);  
        }
    };

    return (        
        <div> 
        {loading ? (
            <div key={uuidv4()} style={{ width:"25%",   display: "flex", 
            marginLeft: "auto", marginRight: "auto" }}> 
             <ThreeDots color="#30720f" height='350' width='150'/>
             </div> 
        ):(
        <div className="content">
            <Tooltip title="Mostra anteprima" placement="left">
                <Fab aria-label="add" onClick={(event) => {onClickToUpdate(event) }}                
                    style={{
                        margin: 0,
                        background: "#30720f",
                        top: 'auto',
                        right: 5,
                        //bottom: 90,                    
                        bottom:155,
                        left: 'auto',
                        position: 'fixed',}}>                    
                        <PreviewIcon />
             
                </Fab>   
            </Tooltip>
            <Tooltip title="Carica Nuovo Allegato" placement="left" disabled={praticaBloccata && localStorage.getItem("ruolo")!="5"}>
                <Fab aria-label="add" onClick={passing2}          
                    style={{
                        margin: 0,
                        background: "#30720f",
                        top: 'auto',
                        right: 5,
                        //bottom: 155,                    
                        bottom: 220,                    
                        left: 'auto',
                        position: 'fixed',}}>                    
                        <AttachFileIcon />
                        <AddIcon fontSize="small" sx={{ position: "absolute", bottom: 6, right: 6, fontSize: "20px" }}/>
             
                </Fab>   
            </Tooltip>
           
            <input id="fileupload00" type="file" name="file" ref={hiddenFileUpload2}
                                onChange={onFileChange2} style={{ display: "none" }} /> 
             <Tooltip title={praticaBloccata ? "Abilita modifica" : "Blocca modifica"} placement="left">
                <Fab aria-label="add" onClick={handleClickFabLock}          
                    style={{
                        margin: 0,
                        background: "#F57C00 ",
                        top: 'auto',
                        right: 5,
                        bottom: 25,                    
                        left: 'auto',
                        position: 'fixed',}}>                                            
                        {praticaBloccata ?(
                            <NoEncryptionGmailerrorredIcon />
                        ):(
                            <HttpsIcon />
                        )}
                        
             
                </Fab>   
            </Tooltip>
            
            <Tooltip title={"Aggiorna dati da EroWeb"} placement="left"  PopperProps={{disablePortal: true}}>
                <div style={{ display: "inline-flex", position: "fixed", bottom: 90, right: 5  }}>
                    <Fab aria-label="add" onClick={handleClickFabUpdate}   
                        disabled={praticaBloccata ? true: false}       
                        style={{
                            margin: 0,
                            background: "#D84A38",
                            //top: 'auto',
                            //right: 5,
                            //bottom: 220,                    
                            //bottom: 90,                    
                            //left: 'auto',
                            //position: 'fixed',
                        }}>                                                                 
                            <SystemUpdateAltIcon />
                    </Fab>   
                </div>
            </Tooltip>            
            <div>
                <div className="common-list" key={"007"}
                    style={{ position:"relative", margin: "0px", paddingLeft: "70px",
                             borderRadius: "0px", borderTopLeftRadius:"8px" , borderTopRightRadius: "8px",                                                                
                             borderBottomLeftRadius:"8px" , borderBottomRightRadius: "8px",                                                                
                             borderBottom:  "1px solid #EFEFEF",
                                marginBottom:"5px",                                                                                              
                                backgroundColor:"white",
                                border: "none",                                                                
                                //marginLeft: item.hide ? "50px": "0px"
                            }}                          
                        >
                            <div style={{ display:"flex", width: "100%", padding: "0px 25px",margin: "5px 0px",
                                            textAlign: "left"}} >
                                        <p className="text importantText">
                                           Numero Pratica:
                                        </p>   
                                        <p style={{paddingLeft:"20px"}}>{idScheda}</p>
                                        {praticaBloccata? (
                                        <Chip style={{marginLeft:"20px", marginTop:"8px", backgroundColor:"#BCF3A1"}}
                                            label="PRONTA PER IL COMITATO"                                            
                                            icon={<DoneIcon />}
                                            
                                        />
                                        ):(
                                            <Chip style={{marginLeft:"20px", marginTop:"8px", backgroundColor:"#F6BD60", color:"black"}}
                                            label="IN PREPARAZIONE"                                            
                                            icon={<DriveFileRenameOutlineIcon />}
                                        />  
                                        )}                                    
                            </div>
                
                </div>
                
                {sedutePrecedenti && 
                <div className="common-list" key={"077"}
                style={{ position:"relative", margin: "0px", paddingLeft: "70px",
                         borderRadius: "0px", borderTopLeftRadius:"8px" , borderTopRightRadius: "8px",                                                                
                         borderBottomLeftRadius:"8px" , borderBottomRightRadius: "8px",                                                                
                         borderBottom:  "1px solid #EFEFEF",
                            marginBottom:"5px",                                                                                              
                            backgroundColor:"white",
                            border: "none",                                                                
                            //marginLeft: item.hide ? "50px": "0px"
                        }}                          
                    >
                        <div style={{ display:"flex", width: "100%", padding: "0px 25px",margin: "5px 0px",
                                        textAlign: "left"}} >
                                    <p className="text importantText">
                                       Altre sedute in cui la pratica è andata in Comitato:
                                    </p>                                                                                                                                                   
                                        <Box>                                        
                                  
                                        <Stack direction="row" spacing={1} flexWrap="wrap">
                                            {/** 
                                          {sedutePrecedenti?.split("#").filter(Boolean).map((date, index) => (
                                            <Chip
                                              key={index}
                                              icon={<EventIcon />}
                                              label={formatDate(date)}
                                              style={{marginLeft:"20px", marginTop:"8px",backgroundColor: "#30720F", color:"black"}}
                                              clickable
                                              color="primary"
                                              variant="filled"
                                              onClick={() => handleChipClick(date)}
                                              sx={{
                                                mb: 1,
                                                cursor: "pointer",
                                                "&:hover": {
                                                  boxShadow: 2,
                                                }
                                              }}
                                            />
                                            ))}*/}
                                            {sedutePrecedenti?.split("#").filter(Boolean).map((entry, index) => {
                                                    const [date, extra] = entry.split("_", 2);
                                                    const hasExtra = Boolean(extra);
                                                    if (hasExtra) {
                                                        return null; 
                                                      }
                                                    return (                                                                                                           
                                                        <Badge badgeContent={
                                                            hasExtra? "M" : ""} 
                                                            //color="#30720E" 
                                                            sx={{
                                                                "& .MuiBadge-badge": {
                                                                  backgroundColor: "#30720E",
                                                                  color: "white",
                                                                },
                                                              }}
                                                            anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'right',
                                                          }}
                                                          invisible={hasExtra? false : true}
                                                          >
                                                        <Chip
                                                        key={index}                                                        
                                                        icon={<EventIcon />}
                                                        label={formatDate(date)}
                                                        clickable
                                                        variant="filled"
                                                        onClick={() =>
                                                        hasExtra
                                                            ? handleChipClickWithMamma(date, extra)
                                                            : handleChipClick(date)
                                                        }
                                                        sx={{
                                                        ml: "20px",
                                                        mt: "8px",
                                                        backgroundColor: "#A2EE7D",
                                                        color: "black",
                                                        cursor: "pointer",
                                                        "&:hover": {
                                                            backgroundColor: "#30720E",
                                                            boxShadow: 2,
                                                        },
                                                        }}
                                                    />
                                                        </Badge>
                                                    
                                                    );
                                                })}
                                        </Stack>
                                      </Box>                                                                            
                        </div>            
                </div>
                }

                {elementiStrategia != undefined && 
                    

                <div className="common-list" key={"009"} style={{marginBottom:"5px", width:"100%"}}>                    
                {elementiStrategia.length !=0  ?(                    
                <div style={{ paddingLeft:"5px", display: "flex", gap:1 }}>                            
                         <div style={{ width: 24 }}>                                                           
                            <IconButton size="small" onClick={() => handleOpenSlide(elementiStrategia,dataSeduta,faseSeduta,idScheda,homeData)}
                            >
                                <AddchartIcon fontSize="small" />
                            </IconButton>                                                                                                                  
                        </div>  
                        </div>    
                        ):<></>}
                    <div style={{ display:"flex", width: "100%", padding: "0px 25px", marginLeft: elementiStrategia.length !== 0 ? "41px" : "70px",
                        marginRight: "10px", marginTop: "5px", marginBottom:"0px", textAlign: "left"}} >

                        
                                    <p className="text importantText" style={{width:"200px"}}>
                                        Elementi di Strategia:
                                    </p>  
                                    <Box style={{paddingLeft:"20px", paddingRight: "15px", width:"100%"}}>
                                        <AmbitiMultiSelect value={elementiStrategia} onChange={(e) => handleChangeElementiStrategia( e)}/>
                                    </Box>               
                    </div>
                </div>
                }

                {homeData.length > 0 &&
                    homeData.filter(item => item.tipo !== "allegato" && item.label !== "Importo Anno In Corso" && item.label !== "Importo Anno Precedente")
                    .map((item, index) =>  (    
                                                                    
                        <div
                            className="common-list"
                            key={index}
                            style={{          
                                position:"relative",                      
                                margin: "0px",
                                paddingLeft: "70px",
                                borderRadius: "0px",
                                borderTopLeftRadius: item.itemcss,
                                borderTopRightRadius: item.itemcss,
                                borderBottom: item.bordercss,    
                                marginBottom:"5px",                                                                                              
                                backgroundColor: item.hide ?"#f0f0f0" :"white",
                                border: item.hide ?"2px dashed #999": "none",
                                opacity: item.hide ? 0.6: 1 ,                                
                                textDecoration: item.hide ? "line-through" : "none",
                                //marginLeft: item.hide ? "50px": "0px"
                            }}                          
                        >

                        {/*{item.label !== "Ragione Sociale" &&item.label !== "Denominazione iniziativa" ? (*/}
                        {/**{item.label !== "Denominazione iniziativa" ? (*/}
                         <div style={{ position: "absolute", top: "25%", left: 4, display: "flex", gap:1 }}>                            
                         <div style={{ width: 24 }}>
                            {item.label=="Ipotesi d'Intervento" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true?(  
                            console.log("VER1",item.label, localStorage.getItem("ruolo") ,praticaBloccata),                                                              
                            <IconButton size="small" onClick={() => handleOpenII(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                            ):
                            item.label=="Ipotesi d'Intervento" && localStorage.getItem("ruolo")=="5" ?(                                                                
                                <IconButton size="small" onClick={() => handleOpenII(item)}>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            ):
                            item.label=="Dettagli Importo Proposto" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true?(  
                                <IconButton size="small" onClick={() => handleOpenDettaglioBudget(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):

                            item.label=="Dettagli Importo Proposto" && localStorage.getItem("ruolo")=="5"?(      
                                <IconButton size="small" onClick={() => handleOpenDettaglioBudget(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):
                            item.label=="Executive Summary" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true ?(      
                                <IconButton size="small" onClick={() => handleOpenER(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):

                            item.label=="Executive Summary" && localStorage.getItem("ruolo")=="5"?(      
                                <IconButton size="small" onClick={() => handleOpenER(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):                            
                            item.label=="Importo Proposto" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true ?(      
                                <IconButton size="small" onClick={() => handleOpenImportoProposto(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):
                            item.label=="Importo Proposto" && localStorage.getItem("ruolo")=="5"?(      
                                <IconButton size="small" onClick={() => handleOpenImportoProposto(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>                          
                            ):
                            item.tipo != "allegato" && item.label!="Importo Proposto" &&item.label!="Executive Summary"  &&item.label!="Dettagli Importo Proposto" &&item.label!="Ipotesi d'Intervento" && item.label!="Importo Anno Precedente" &&  item.label!="Importo Anno In Corso" &&  item.label!="Ragione Sociale" &&  item.label!="Obiettivo" &&  item.label!="Missione" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true?
                            (                                  
                                <IconButton size="small" onClick={() => handleOpen(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                            )
                            :
                            item.tipo != "allegato" && item.label!="Importo Proposto" &&item.label!="Executive Summary"  &&item.label!="Dettagli Importo Proposto" &&item.label!="Ipotesi d'Intervento" && item.label!="Importo Anno Precedente" &&  item.label!="Importo Anno In Corso" &&  item.label!="Ragione Sociale" &&  item.label!="Obiettivo" &&  item.label!="Missione" && localStorage.getItem("ruolo")=="5"?
                            (                                  
                                <IconButton size="small" onClick={() => handleOpen(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                            )
                            :(<></>)                         
                        }
                        </div>    
                        <div style={{ width: 24 }}>
                        {  item.tipo != "allegato" &&  item.label!="Denominazione iniziativa" &&  item.label!="Importo Anno Precedente" &&  item.label!="Importo Anno In Corso" &&  item.label!=="Dettagli Importo Proposto" &&  item.label!=="Importo Proposto" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true?                            
                            (                            
                            <IconButton size="small" onClick={() => handleHide(item)}>
                                <VisibilityOffIcon fontSize="small" />
                            </IconButton>
                            )
                            :
                            item.tipo != "allegato" &&  item.label!="Denominazione iniziativa" &&  item.label!="Importo Anno Precedente" &&  item.label!="Importo Anno In Corso" &&  item.label!=="Dettagli Importo Proposto" &&  item.label!=="Importo Proposto" && localStorage.getItem("ruolo")=="5"?                            
                            (                            
                            <IconButton size="small" onClick={() => handleHide(item)}>
                                <VisibilityOffIcon fontSize="small" />
                            </IconButton>
                            )
                            :
                            (<></>)}
                            </div> 
                        </div> 
                        {/*}):(<></>)}*/}
                        
                            {item.componentRef && !item.comment ? (
                                item.label === "Executive Summary" ? (       
                                    //console.log("PDD",item.newValue, item.value),                           
                                    <div style={{ display:"block", width: "100%", padding: "0px 25px", margin: "20px 0px",
                                            textAlign: "left", cursor: "pointer"}} onClick={() => goFinalInfo(item.componentRef)}>
                                        <p className="text importantText">
                                           {item.label}:
                                        </p>                                      
                                        
                                        <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>
                                        {item.table ? (
                                            item.table.map((extraitem, index) => (
                                            //console.log("uff",item),
                                                <div key={index} style={{ paddingBottom: "20px" }}>  
                                                    {/*<p className="text"                                            
                                                        dangerouslySetInnerHTML={{__html: extraitem[3]}} />  */}
                                                    <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: extraitem[3]}}/>
                                                </div>
                                            ))
                                    ) : ( <></> )}
                                    </div>
                                ) : (  /** DENOMINZA INIZIATIVA E RAGIONE SOCIALE*/                      
                                    <div style={{ display:"block", width: "100%", padding: "0px 25px", margin: "20px 0px",
                                            textAlign: "left", cursor: "pointer",  }}
                                          onClick={() => goFinalInfo(item.componentRef)}>
                                        <p className="text importantText textInLine "> {item.label}: </p>
                                        {/*<p className="text normalTextInLine"
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value }}/>        */}
                                              <div className="text normalTextInLine" style={{ whiteSpace: 'normal' }}
                                                    dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>
                                    </div>
                                )
                            ) : !item.componentRef && !item.comment && (item.style === 0 || item.style === 2) ? (
                                item.label === "Executive Summary" ? (

                                    <div style={{ textAlign: "left", paddingLeft: "25px", paddingRight: "25px" }}>
                                        <p className="text importantText">
                                            {item.label}:
                                        </p>                                        
                                        <div style={{ paddingBottom: "20px", whiteSpace: 'pre-wrap' }}>      
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                                    dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>                   
                                            {/*<p className="text" style={{whiteSpace: 'pre-wrap' }}
                                                dangerouslySetInnerHTML={{__html: item.newValue || item.value }}/>*/}                                            
                                        </div>

                                        {item.table &&
                                            item.table.map(
                                                (extraitem, index) => (                                            
                                                    <div key={index} style={{ paddingBottom:"20px" }} >
                                                        {/*<p className="text normalTextInLine"  style={{ whiteSpace: 'pre-wrap' }}
                                                            dangerouslySetInnerHTML={{__html: extraitem[3],}}/>*/}
                                                            <div className="text normalTextInLine" style={{ whiteSpace: 'normal' }}
                                                                dangerouslySetInnerHTML={{ __html: extraitem[3]}}/>                   
                                                    </div>   
                                                )
                                        )}
                                    </div>
                                ) : item.label === "Descrizione" ? (  
                                    //console.log("e122",item.value),                              
                                    <div style={{textAlign: "left", padding: "0px 15px"}}>
                                        <p className="text importantText">
                                            {item.label}:
                                        </p>
                                        <p className="text" style={{textAlign: "justify" }}>
                                            {item.newValue || item.value}
                                        </p>
                                    </div>
                                ): item.label === "Importo Anno Precedente" || item.label === "Importo Anno In Corso" ?(                                   
                                    <div></div>
                                ):item.label === "Importo Proposto"   ? (  
                                    <div style={{ width: "100%",   paddingRight: "25px"}}>
                                        <div style={{ textAlign: "left", padding: "0px 25px", display: "flex", gap: "20px"}}>
                                            <p className="text importantText">
                                                {item.label}:
                                            </p>
                                            <p className="text" style={{ textAlign: "justify" }}> 
                                                {getMoneyAsStringFromDouble(item.newValue || item.value,true)}
                                            </p>
                                        </div>
                                        <div style={{ flex: 1, marginBottom: '16px',   position:"relative", margin: "0px",  gap: "20px",                                                    
                                            backgroundColor :"white", display: "flex", textAlign: "left", paddingLeft:"25px", width: "100%" }}>   
                                            <table style={{borderCollapse: "collapse", width: "100%", marginBottom:"10px", marginRight:"10px" }}>
                                                <thead>
                                                    <tr>                                                   
                                                        <th key={"lab-01"} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px", }}>
                                                        {"Importo Anno In Corso"}
                                                        </th>
                                                        <th key={"lab-02"} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px", }}>
                                                        {"Importo Anno Precedente"}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>                                                                                                                                            
                                                        <tr key={"val-01"} style={{height:"40px"}}>
                                                            {homeData.find(item => item.label === "Importo Anno In Corso").newValue != undefined ?(
                                                                console.log("MAD2",homeData.find(item => item.label === "Importo Anno In Corso")?.newValue,getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno In Corso")?.newValue,true)),
                                                                <td key={"val-0101"} style={{border: "1px solid #ccc", padding: 8 }}>        
                                                                    {getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno In Corso")?.newValue,true)}
                                                                </td>
                                                            ):(
                                                                <td key={"val-0101"} style={{border: "1px solid #ccc", padding: 8 }}>        
                                                                    {getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno In Corso")?.value,true)}
                                                                </td>    
                                                            )}
                                                                
                                                            {homeData.find(item => item.label === "Importo Anno Precedente").newValue != undefined ?(
                                                                console.log("MAD",homeData.find(item => item.label === "Importo Anno Precedente")?.newValue,getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno Precedente")?.newValue,true)),
                                                                <td key={"val-0102"} style={{border: "1px solid #ccc", padding: 8 }}>        
                                                                    {getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno Precedente")?.newValue,true)} 
                                                                </td>                                                                        
                                                            ):(
                                                                <td key={"val-0102"} style={{border: "1px solid #ccc", padding: 8 }}>        
                                                                    {getMoneyAsStringFromDouble(homeData.find(item => item.label === "Importo Anno Precedente")?.value,true)} 
                                                                </td>                                                                        
                                                            )}                                                                                        
                                                        </tr>                                                
                                                </tbody>
                                            </table>                                      
                                        </div>
                                    </div>
                                ): item.label === "Dettagli Importo Proposto" ? (                                      
                                    <div style={{ textAlign: "left", padding: "0px 0px", paddingLeft:"25px", width: "100%", paddingRight:"10px"}}>
                                        <p className="text importantText">
                                            {item.label}:
                                        </p>
                                        
                                        <table style={{borderCollapse: "collapse", width: "100%", marginBottom:"10px", marginRight:"10px" }}>
                                            <thead>
                                                <tr >                                                
                                                    {visibleDettaglioCols.map((colIndex) => (
                                                        <th key={colIndex} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px", }}>
                                                            {item.table[0]?.[colIndex]}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {hasFilteredRows(item.table) ? (
                                                item.table.slice(2).filter(row => row[4] !== "0,00" || row[5] !== "0,00").map((row, rowIndex) => (                                                
                                                    <tr key={rowIndex} style={{height:"40px"}}>
                                                        {visibleDettaglioCols.map((colIndex) => (                                                                  
                                                                <td key={colIndex} style={{border: "1px solid #ccc", padding: 8 }}>
                                                                {colIndex === 3 
                                                                    ? row[colIndex] 
                                                                    : getMoneyAsStringFromDouble(row[colIndex], true)
                                                                }
                                                            </td>   
                                                        ))}   
                                                    </tr>   
                                                ))
                                            ):(
                                                <tr>
                                                <td colSpan={visibleDettaglioCols.length} style={{ textAlign: 'center', color: '#888' }}>
                                                  Nessun dato caricato
                                                </td>
                                              </tr> 
                                            )}
                                            </tbody>
                                        </table>                                        
                                    </div>                                 
                                 ):item.label === "Localizzazione" ? (                                           
                                    <div style={{ paddingLeft: "25px", display:"inline", textAlign: "left", padding: "0px 25px", margin: "20px 0px"}}>
                                        <p className="text importantText textInLine" >
                                            {item.label}:
                                        </p>
                                      
                                        <div className="text normalTextInLine" style={{ whiteSpace: 'normal',paddingRight: "25px" }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>                   
                                    </div>                                                                    
                                ):(                                 
                                    <div style={{ paddingLeft: "25px", display:"inline", textAlign: "left", padding: "0px 25px", margin: "20px 0px"}}>
                                        <p className="text importantText textInLine" >
                                            {item.label}:
                                        </p>
                                        {/*<p className="text normalTextInLine" style={{ paddingRight: "25px", whiteSpace: 'pre-wrap' }}
                                            dangerouslySetInnerHTML={{__html: item.newValue || item.value,}}/>*/}
                                        <div className="text normalTextInLine" style={{ whiteSpace: 'normal',paddingRight: "25px" }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>                   
                                    </div>
                                )) : item.style && item.second ? (
                                    //console.log("II",item),
                                    <div style={{ background: "#a2ee7d", color: "#4B0307", textAlign: "left", padding: "0px 25px", width:"100%" }} className="company-info">
                                        <Accordion style={{ background: "#a2ee7d", boxShadow: "unset"}}>
                                            <AccordionSummary expandIcon={<InfoIcon style={{ color: "#30720f", top: "-32px !important",background:"unset !important" }} /> }
                                                    aria-controls="panel1a-content" id="panel1a-header"
                                                    style={{userSelect: "text", padding: "0px", flexDirection: "unset"}}>
                                                <Typography component={'div'}>
                                                    <div style={{ display: "flex",alignItems: "center", justifyContent: "space-between"}}>
                                                        <p className="text importantText" > {item.label}: </p>
                                                    </div>
                                                    {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: item.newValue || item.value }} />                                                */}
                                                    <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>                   
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails style={{ padding: "0px" }}>
                                                <Typography component={'div'}>                                                
                                                    <p className="text importantText"> Ruolo della compagnia: </p>
                                                    {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: item.second}}/>    */}
                                                    <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: item.second}}/>                   
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>
                                        {item.comment ? (                                                                            
                                                <div style={{ color: "#879497", padding: "0px 25px", border: "1px solid #30720f", borderRadius: "20px", margin: "40px 0px" }}>
                                                    <p className="text" style={{ fontSize: "14px" }}> Commento: </p>

                                                    <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: item.comment}}/>
                                                    {/*<p className="text" style={{ whiteSpace: 'pre-wrap', fontSize: "14px" }} dangerouslySetInnerHTML={{__html: item.comment }}/>  */}
                                                </div>                                            
                                        ):(<></>)}                                
                                    </div>
                                ) : item.comment && item.label!="Elementi di valutazione"? (                                
                                    <div style={{ textAlign: "left", padding: "0px 25px",  width:"100%",  }} >
                                        <div>
                                            <p className="text importantText"> {item.label}: </p>
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>
                                            {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: item.newValue || item.value}}/>                                               */}
                                        </div>
                                        <div style={{ color: "#879497", padding: "0px 25px", border: "1px solid #30720f", borderRadius: "20px", margin: "40px 0px" }}>
                                            <p className="text" style={{ fontSize: "14px" }}> Commento: </p>
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.comment}}/>
                                            {/*<p className="text" style={{ whiteSpace: 'pre-wrap', fontSize: "14px" }} dangerouslySetInnerHTML={{__html: item.comment }}/>  */}
                                        </div>
                                    </div>
                                ) : item.comment && item.label=="Elementi di valutazione"? (                                
                                    <div style={{ textAlign: "left", padding: "0px 25px",  backgroundColor:"rgb(162, 238, 125)", width:"100%" }} >
                                        <div>
                                            <p className="text importantText"> {item.label}: </p>
                                            {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: item.newValue || item.value}}/>                                               */}
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>  
                                        </div>
                                        <div style={{ color: "#879497", padding: "0px 25px", border: "1px solid #30720f", borderRadius: "20px", margin: "40px 0px" }}>
                                            <p className="text" style={{ fontSize: "14px" }}> Commento: </p>
                                            {/*<p className="text" style={{ whiteSpace: 'pre-wrap', fontSize: "14px" }} dangerouslySetInnerHTML={{__html: item.comment }}/>  */}
                                            <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.comment}}/>
                                        </div>
                                    </div>
                                ) : item.style && !item.comment && !item.secondValue && !item.componentRef ? (                              
                              
                                    <div style={{ background: "#a2ee7d", color: "#4B0307", textAlign: "left", padding: "0px 25px", border: "1px solid rgb(239, 239, 239)", width: "100%",paddingBottom:"20px"}}>                                
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>                                   
                                            <p className="text"> {item.label}:  </p>
                                        </div>                            
                                        {/*<p className="text" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: item.newValue || item.value }}/>                                       */}
                                        <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            {item.componentRef ? ( //PER FRECCIA PER SECONDA PAGINA - SCEHDA ENTE, INIZIATIVA , ETC.                             
                                <div style={{ paddingRight: "25px", color: "#879497", display: "flex", cursor:"pointer" }}
                                    onClick={() => goFinalInfo(item.componentRef)} >
                                    <KeyboardArrowRightIcon sx={{ color: '#879497' }} fontSize="large"/>
                                </div>
                            ) : ( <></>)}
                            
                        </div>
                    
                    ))}
       {1>2 ? (
                    <div style={{     
                        position:"relative",      
                        margin: "0px",                                                       
                        backgroundColor :"white",
                        display: "flex",
                        textAlign: "left",                                                                                        
                        paddingLeft:"70px",                        
                        gap: "20px"}}>                           
                            <p className="text importantText"  style={{ paddingLeft: "25px", color: "#30720f"}}>
                                Fasce d'età:
                            </p>
                           
                    </div>
       ):(<></>)}

                    <div style={{ flex: 1, marginBottom: '5px',   position:"relative",      
                        margin: "0px",                                                       
                        backgroundColor :"white",
                        display: "flex",
                        textAlign: "left",                                                                                        
                        paddingLeft:"95px",                                                                        
                        gap: "20px"            
                         }}>                       
                    </div>


                    <div style={{     
                        position:"relative",      
                        margin: "0px",                                                       
                        backgroundColor :"white",
                        display: "flex",
                        textAlign: "left",                                                                                        
                        paddingLeft:"70px",                        
                        gap: "20px"}}>
                           <div style={{ position: "absolute", top: "25%", left: 4, display: "flex", gap:1 }} >                            

                            {localStorage.getItem("ruolo")!="5" && praticaBloccata!=true ? (                              
                                    <IconButton size="small" onClick={() => handleOpenAllegati()}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                ): localStorage.getItem("ruolo")=="5" ? (
                                    <IconButton size="small" onClick={() => handleOpenAllegati()}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                ):(<></>)}
                            </div>

                            <p className="text importantText"  style={{ paddingLeft: "25px", color: "#30720f"}}>
                                Allegati:
                            </p>
                            {/*<>
                                <button  onClick={(event) => passing2(event)} style={{ marginLeft: "10px", width:'250px', marginTop:"10px",marginBottom:"10px",
                                borderTopLeftRadius: "15px", borderTopRightRadius: "15px",
                                borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px",
                                borderColor:"#30720f",  fontSize:"15px",                                      
                                backgroundColor :"white", color:"#30720f"}}>Carica Nuovo Allegato</button>
                                <input id="fileupload00" type="file" name="file" ref={hiddenFileUpload2}
                                onChange={onFileChange2} style={{ display: "none" }} /> 
                    </> */}
                    </div>
                                        
                     <div style={{ flex: 1, marginBottom: '16px',   position:"relative",      
                        margin: "0px",                                                       
                        backgroundColor :"white",
                        display: "flex",
                        textAlign: "left",                                                                                        
                        paddingLeft:"95px",                        
                        //paddingRight:"25px",                        
                        gap: "20px" }}>
                        <table style={{borderCollapse: "collapse", width: "100%", marginRight:"10px",marginBottom:"10px" }}>
                        <thead>
                            <tr>
                                <th key="1.col" style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px" }}>
                                {"Sezione"}
                                </th>              
                                <th key="2.col" style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px" }}>
                                {"Nome file"}
                                </th>
                                <th key="3.col" style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px" }}>
                                {"Dimensione"}
                                </th>
                                <th key="4.col" style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", fontSize:"14px" }}>
                                {"Data caricamento"}
                                </th>
                            </tr>
                        </thead>

                        <tbody>         
                            { attachmentsAvailable(homeData) ?(
                            homeData.length > 0 && homeData.filter(item => item.tipo == "allegato")
                                .map((row, rowIndex) => (                                   
                                    
                                <tr key={rowIndex}>                                
                                    <td key={row['key']+"1"} style={{border: "1px solid #ccc", padding: 8 }}>                                              
                                        {row["sezione"]}                                              
                                    </td>
                                    <td key={row['key']+"2"} onClick={() => handleTdClick(row)} style={{border: "1px solid #ccc", padding: 8, cursor: "pointer" }}>                                              
                                        {row["label"]}                                              
                                    </td>
                                    <td key={row['key']+"3"} style={{border: "1px solid #ccc", padding: 8 }}>                                              
                                        {row["dimensione"]}                                              
                                    </td>
                                    <td key={row['key']+"4"} style={{border: "1px solid #ccc", padding: 8 }}>                                              
                                        {row["data_modifica"]}                                              
                                    </td>
                                </tr> 
                            ))
                        ):(
                            <tr>
                            <td colSpan={4} style={{ textAlign: 'center', color: '#888' }}>
                              Nessun allegato caricato
                            </td>
                          </tr> 
                        
                        )}
                        </tbody>
                        </table>
                </div>

            </div>
        {praticaUltimaModifica != '' || praticaModificataDa !='' ?(
            <p>
            Ultima modifica sulla pratica effettuata il:<strong> {praticaUltimaModifica} </strong>, dall'utente: <strong> {praticaModificataDa} </strong> 
            </p>          
        ):(<></>)}
        </div>
    )}

     <Modal
        open={open}
        keepMounted={false} 
        onClose={handleClose}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div style={{ position: 'absolute', top: '5%', left: '5%', width: '90%', height: '90%',
            backgroundColor: 'white', padding: '20px', overflow: 'auto', boxShadow: 24,
            borderRadius: '8px', display: 'flex',flexDirection: 'column',}} >

            <h2 id="edit-modal-title">Modifica {openedLabel}</h2>
            <div style={{ flex: 1, marginBottom: '16px' }}>           
            
                <Editor   value={editorContent}                       
                       onEditorChange={handleEditorChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],                                                        
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
                                    
                        <Accordion sx={{ boxShadow: "none", backgroundColor: "transparent"}} >
                            <AccordionSummary >
                                <Typography fontSize={14} color="#777">
                                    Mostra valore originale
                                </Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                                <div className="text" style={{ whiteSpace: 'normal',color:"#aaa", fontStyle: "italic",paddingTop:"10px" }}
                                            dangerouslySetInnerHTML={{ __html: itemContent.value}}/>   
                            </AccordionDetails>
                        </Accordion>                
                                 
                
            </div>
            <h2 id="edit-modal-title">Commento</h2>
            <div style={{ flex: 1, marginBottom: '16px' }}>            
                <Editor   value={commentContent}
                       onEditorChange={handleEditorCommentChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
            </div>

            <div style={{ paddingTop:"10px", textAlign: 'right' }}>
                <button className="button154" onClick={handleClose} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
                <button className="button11" onClick={handleSave} style={{ marginRight: 10, width:'100px' }}>Salva</button>
            </div>
        </div>
      </Modal>

      <Modal
        open={openII}
        keepMounted={false} 
        onClose={handleCloseII}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Format DELIBERA</h2> 
          <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                <InfoOutlinedIcon color="primary" style={{marginTop:"-10px" }}/>
                <p style={{marginTop:"-10px", color:"black", fontWeight:600}}> Selezionare un format per la compilazione della ipotesi di intervento </p> 
          </Stack>
          <Select labelId="select-label" id="simple-select" multiple value={formatModel} label=""       
              open={selectOpen}
              onOpen={() => setSelectOpen(true)}
              onClose={() => setSelectOpen(false)}     
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((val) => (
                    <Chip key={val} label={menuLabels[val]} size="small" 
                    onDelete={(e) => handleDeleteChip(val, e)}
                    onMouseDown={(e) => e.stopPropagation()}/>
                  ))}
                </Box>
              )}            
             onChange={(e) => {
                    handleChangeSelectTemplate(e.target.value);
                    setSelectOpen(false);   // chiude subito dopo la selezione
            }}>                            
                <MenuItem value={1}>Delibera di stanziamento</MenuItem>
                <MenuItem value={2}>Delibera di accantonamento</MenuItem>
                <MenuItem value={3}>Delibera di approvazione di bandi/linee guida</MenuItem>
                <MenuItem value={4}>Delibera di approvazione esiti di bandi/linee guida</MenuItem>
                <MenuItem value={5}>Delibera di approvazione di convenzioni/protocolli d'intesa/ accordi quadro</MenuItem>
                <MenuItem value={6}>Modifiche statutarie di Enti strumentali e partecipati </MenuItem>
                <MenuItem value={7}>Informativa per aggiornamento su progetti</MenuItem>
                <MenuItem value={8}>Richiesta di parere</MenuItem>
                <MenuItem value={9}>Delibera di ridestinazione</MenuItem>
                <MenuItem value={10}>Delibera per progetti/azioni pluriennali</MenuItem>        
                <MenuItem value={0}>Modello Libero</MenuItem>
          </Select>
          {suggestion !== null ? (
              <Paper
              elevation={0}
              sx={{
                p: 2,
                mb: 2,
                marginTop:'10px',
                //border: '1px solid #D6E4FF',
                border: '1px solid #EEEEEE',
                //backgroundColor: '#F5F9FF'#f5f3f0,
                backgroundColor: '#f5f3f0',
                borderRadius: 2
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center" mb={1}>                
                
                <Typography variant="subtitle1" fontWeight={600}>
                  Linee guida per la compilazione dell'Ipotesi di Intervento, che possono essere usate come spunto, da riportare nel campo successivo
                </Typography>
              </Stack>
          
              <Typography variant="body2" component="div" sx={{ color: 'text.secondary', mb: 2}}>
               {suggestion}
              </Typography>
              </Paper>
          ):(<></>)
          }

          <h2 id="edit-modal-title">Modifica IPOTESI INTERVENTO</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          
             <Editor   value={editorIpotesi}
                       onEditorChange={handleEditorIpotesiChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            branding: false,
                            statusbar:false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>


          </div>
          <h2 id="edit-modal-title">Modifica RUOLO DELLA COMPAGNIA</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
         
             <Editor   value={editorRuolo}
                       onEditorChange={handleEditorRuoloChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
          </div>        
          <h2 id="edit-modal-title">Commento</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>          
               <Editor   value={commentContent}
                       onEditorChange={handleEditorCommentChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
          </div> 
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseII} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveII} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>

      <Modal
        open={openER}
        keepMounted={false} 
        onClose={handleCloseER}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica EXECUTIVE SUMMARY</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          
          <Editor   value={editorExecutive}
            onEditorChange={handleEditorExecutiveChange}
            init={{ base_url: '/tinymce',
                suffix: '.min',        
                license_key: 'gpl',
                promotion: false,
                height: 250,
                menubar: false,
                branding: false,
                statusbar:false,
                plugins: [ 'lists','link'],
                toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}/>
          </div>
          <h2 id="edit-modal-title">Modifica RELAZIONE/ANNOTAZIONI</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
         
          <Editor   value={editorRelazione}
            onEditorChange={handleEditorRelazioneChange}
            init={{ base_url: '/tinymce',
                suffix: '.min',        
                license_key: 'gpl',
                promotion: false,
                height: 250,
                menubar: false,
                statusbar:false,
                branding: false,
                plugins: [ 'lists','link'],
                toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}/>
          </div>        
          <h2 id="edit-modal-title">Commento</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
        
          <Editor   value={commentContent}
            onEditorChange={handleEditorCommentChange}
            init={{ base_url: '/tinymce',
                suffix: '.min',        
                license_key: 'gpl',
                promotion: false,
                height: 250,
                menubar: false,
                statusbar:false,
                branding: false,
                plugins: [ 'lists','link'],
                toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}/>
          </div> 
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseER} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveER} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>


      <Modal
        open={openDettaglioBudget}
        onClose={handleCloseDettaglioBudget}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica allocazione Importo Proposto</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          <table style={{borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>
                {visibleDettaglioCols.map((colIndex) => (
                <th key={colIndex} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1"  }}>
                  {tableContent[0]?.[colIndex]}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
          <tr key={"tot00"} style={{color:"grey"}}>                                                        
                    <td key={"tot00-1"} style={{border: "1px solid #ccc", padding: 8 }}>
                    {"Importo Proposto"}
                    </td>   
                    <td key={"tot00-2"} style={{border: "1px solid #ccc", padding: 8 }}>            
                    {parseFloat(editorAnnoInCorso).toFixed(2).replace('.', ',')}
                    </td>   
                    <td key={"tot00-3"} style={{border: "1px solid #ccc", padding: 8 }}>                                
                    {parseFloat(editorAnnoPrecedente).toFixed(2).replace('.', ',')}
                    </td>                                                             
          </tr>  
          <tr key={"tot01"} style={{color:"grey"}}>                                                        
                    <td key={"tot01-1"} style={{border: "1px solid #ccc", padding: 8 }}>
                    {"Importo Proposto già suddiviso"}
                    </td>   
                    <td key={"tot01-2"} style={{border: "1px solid #ccc", padding: 8, 
                     /*color: tableContent.slice(2).reduce((acc, row) =>
                           acc + (parseFloat(row[4].replace(/\./g, "").replace(",", ".")) || 0),0
                ) != parseFloat(editorAnnoInCorso).toFixed(2).replace('.', ',') ? "#f00" : "#ccc" */
                color: tableContent.slice(2).reduce((acc, row) =>
                    acc + (parseFloat(row[4].replace(/\./g, "").replace(",", ".")) || 0),0) !== parseFloat(editorAnnoInCorso) ? "#f00": "grey"}}>
                    {tableContent.slice(2).reduce((acc, row) =>
                        acc + (parseFloat(row[4].replace(/\./g, "").replace(",", ".")) || 0),0).toFixed(2)
                        .replace(".", ",")}                       
                    </td>   
                    <td key={"tot01-3"} style={{border: "1px solid #ccc", padding: 8, 
                     /*color: tableContent.slice(2).reduce((acc, row) =>
                           acc + (parseFloat(row[5].replace(/\./g, "").replace(",", ".")) || 0),0
                    ) != parseFloat(editorAnnoPrecedente).toFixed(2).replace('.', ',') ? "#f00" : "#ccc" */
                    color: tableContent.slice(2).reduce((acc, row) =>
                    acc + (parseFloat(row[5].replace(/\./g, "").replace(",", ".")) || 0),0) !== parseFloat(editorAnnoPrecedente) ? "#f00": "grey"}}>
                    {tableContent.slice(2).reduce((acc, row) =>
                        acc + (parseFloat(row[5].replace(/\./g, "").replace(",", ".")) || 0),0).toFixed(2)
                        .replace(".", ",")}                       
                    </td>   
              </tr>  
            {tableContent.slice(2).map((row, rowIndex) => (
              
              <tr key={rowIndex}  style={{ 
                backgroundColor: rowIndex % 2 === 0 ? "#ffffff" : "#f7f7f7" 
              }}>
            
                  {visibleDettaglioCols.map((colIndex) => (
                  
                  <td key={colIndex} //style={{border: "1px solid #ccc", padding: 8 }}
                  style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "transparent" }}>
                  
                    {(colIndex === 4 || colIndex === 5) ? (
                      <input
                        type="text"
                        value={row[colIndex]}
                        onFocus={(e) => { 
                            e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                            e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                        }}
                        onBlur={(e) => { 
                            e.target.parentElement.style.backgroundColor = "#fff";
                            e.target.parentElement.style.boxShadow = "none";
                        }}    
                        onChange={(e) =>
                            //handleChangeInTable(rowIndex + 1, colIndex, e.target.value)
                            handleChangeInTable(rowIndex+2, colIndex, e.target.value)
                        }
                        style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "16px", padding: "2px 0", cursor: "text"}}
                      />
                    ) : (
                      row[colIndex]
                    )}
                  </td>
                ))}   
              </tr>
              
            ))}
          </tbody>
        </table>
          </div>
         
        
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseDettaglioBudget} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveDettaglioBudget} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>
    
    
      <Modal
        open={openAllegati}
        onClose={handleCloseAllegati}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica Allegati</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          <table style={{borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>    
                <th key={"head"+0} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", width:"5%"  }}>
                  {""}
                </th>                     
                <th key={"head"+1} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", width:"28%"  }}>
                  {"Riferimento file"}
                </th>
                <th key={"head"+2} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"37%"  }}>
                  {"Nome file mostrato"}
                </th>
                <th key={"head"+3} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"20%"  }}>
                  {"Sezione"}
                </th>
                <th key={"head"+4} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"10%"  }}>
                  {"Posizione"}
                </th>
            </tr>
          </thead>

          <tbody>
            {tableAllegati.length > 0 ? (  
                //console.log(">0",tableAllegati,tableAllegati.length),              
                tableAllegati.map((row, rowIndex) => (              
                <tr key={rowIndex}>                                                           
                            <td key={row.key + "_q0"}
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                                <IconButton size="small" onClick={() => handleDeleteRow(row.key)}>
                                    <DeleteIcon fontSize="small" style={{color:"#bf360c"}}/>
                                </IconButton>
                                
                            </td>
                            <td key={row.key + "_q1"} onClick={() => handleTdClick(row)}
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff", cursor: "pointer"}}>
                                <p style={{fontSize: "14px", padding: "2px 0", color:"rgb(84, 84, 84)" }} >{row["value"]} </p>
                                {/*
                                <input type="text" value={row["value"]}   disabled                             
                                    style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "14px", padding: "2px 0", cursor: "pointer"}}
                                    
                                    />
                                */}
                            </td>
                            <td key={row.key + "_q2"}
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                                
                                <input type="text" value={row["label"]}                                
                                    style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "14px", padding: "2px 0", cursor: "text"}}
                                    onChange={(e) => handleChangeInAllegatiTable(rowIndex, "label", e.target.value)}
                                    onFocus={(e) => { 
                                        e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                                        e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                    }}
                                    onBlur={(e) => { 
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                    }}/>
                            </td>

                            <td key={row.key+"_q3"} 
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                                <select value={row["sezione"]}
                                    onChange={(e) =>
                                        handleChangeInAllegatiTable(rowIndex, "sezione", e.target.value)
                                    }
                                    style={{ width: "100%", border: "none", outline: "none", background: "transparent", fontSize: "14px",
                                        padding: "2px 0", cursor: "pointer", appearance: "none", WebkitAppearance: "none", MozAppearance: "none" }}
                                    onFocus={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#f5f7fa";
                                        e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                    }}
                                    onBlur={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                    }}>
                                        <option value="SCHEDA INIZIATIVA">SCHEDA INIZIATIVA</option>
                                        <option value="SCHEDA ENTE">SCHEDA ENTE</option>
                                        <option value="EXECUTIVE SUMMARY">EXECUTIVE SUMMARY</option>
                                        <option value="RELAZIONE ANNOTAZIONI">RELAZIONE ANNOTAZIONI</option>
                                        
                                </select>
                                {/** 
                                <span
                                        style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)",
                                            pointerEvents: "none", fontSize: "10px", color: "#666"}}> ▼
                                </span>
                                */}        
                                
                            </td>                
                            <td key={row.key + "_q4"}
                                style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                                {/** 
                                <input type="text" value={row["posizione"]}                                
                                    style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "14px", padding: "2px 0", cursor: "text"}}
                                    onChange={(e) => handleChangeInAllegatiTable(rowIndex, "posizione", e.target.value)}
                                    onFocus={(e) => { 
                                        e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                                        e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                    }}
                                    onBlur={(e) => { 
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                    }}/>
                                */}
                                <select value={row["posizione"]}
                                    onChange={(e) =>
                                        handleChangeInAllegatiTable(rowIndex, "posizione", e.target.value)
                                    }
                                    style={{ width: "100%", border: "none", outline: "none", background: "transparent", fontSize: "14px",
                                        padding: "2px 0", cursor: "pointer", appearance: "none", WebkitAppearance: "none", MozAppearance: "none" }}
                                    onFocus={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#f5f7fa";
                                        e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                    }}
                                    onBlur={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                    }}>
                                        <option value="0">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                        <option value="19">19</option>
                                        <option value="20">20</option>                                    
                                </select>
                            </td>
                </tr>                                
                ))): (
                    //console.log("==0",tableAllegati,tableAllegati.length),              
                        <tr>
                        <td colSpan={5} style={{ textAlign: 'center', color: '#888' }}>
                          Nessun allegato presente
                        </td>
                      </tr>   
                    )
            }
          </tbody>
        </table>
          </div>
         
        
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseAllegati} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveAllegati} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>


      <Modal
        open={openImporto}
        onClose={handleCloseImportoProposto}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica Suddivisione Importo Proposto</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>
          <table style={{borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>                   
                <th key={"head"+1} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1", width:"30%"  }}>
                  {"Importo Proposto"}
                </th>
                <th key={"head"+2} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"33%"  }}>
                  {"Importo Anno In Corso"}
                </th>
                <th key={"head"+3} style={{border: "1px solid #ccc", padding: 8, background: "#BCF3A1",width:"33%"  }}>
                  {"Importo Anno Precedente"}
                </th>                
            </tr>
          </thead>

          <tbody>                
              <tr key={"001"}>                                                                                  
                        <td key={"001_q1"}
                            style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                            
                            <input type="text" 
                            //value={parseFloat(homeData.find(item => item.label === "Importo Proposto")?.value).toFixed(2).replace(".", ",")}
                            value={(() => {
                                const raw = homeData.find(
                                  item => item.label === "Importo Proposto"
                                )?.value;
                            
                                if (raw == null || raw === "") return "";
                            
                                let v = raw;
                            
                                if (typeof v === "string" && v.includes(",")) {
                                  v = v.replaceAll(".", "").replace(",", ".");
                                }
                            
                                const n = Number(v);
                            
                                if (isNaN(n)) return "";
                            
                                return n.toFixed(2).replace(".", ",");
                              })()}
                               disabled                                                         
                                style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "16px", padding: "2px 0", cursor: "text"}}                                
                                />
                        </td>
                        <td key={"001_q2"}
                            style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                            {/*
                            <input type="text"                             
                            //value={editorAnnoInCorso.replace(".", ",")}   
                            value={(() => {
                                const raw = editorAnnoInCorso;
                            
                                if (raw == null || raw === "") return "";
                            
                                let v = raw;
                            
                                if (typeof v === "string" && v.includes(",")) {
                                  v = v.replaceAll(".", "").replace(",", ".");
                                }
                            
                                const n = Number(v);
                            
                                if (isNaN(n)) return "";
                            
                                return n.toFixed(2).replace(".", ",");
                              })()}
                                inputMode="decimal"                            
                                style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "16px", padding: "2px 0", cursor: "text",                                
                                  color: toNumberIT(editorAnnoInCorso) +
                                  toNumberIT(editorAnnoPrecedente) !==
                                  toNumberIT(homeData.find(item => item.label === "Importo Proposto")?.value)
                              ? "red"
                              : "black"  
                            }}
                                onChange={(e) => handleChangeImportoProposto("Importo Anno In Corso", e.target.value)}
                                                                
                                onFocus={(e) => { 
                                    e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                                    e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                }}
                                onBlur={(e) => { 
                                    e.target.parentElement.style.backgroundColor = "#fff";
                                    e.target.parentElement.style.boxShadow = "none";
                                    handleChangeImportoProposto("Importo Anno In Corso", sanitizeImporto(e.target.value))
                                }}
                                />*/}
                                <input
                                    type="text"
                                    value={editorAnnoInCorso ?? ""}
                                    inputMode="decimal"
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        background: "transparent",
                                        fontSize: "16px",
                                        padding: "2px 0",
                                        cursor: "text",
                                        color:
                                        toNumberIT(editorAnnoInCorso) +
                                            toNumberIT(editorAnnoPrecedente) !==
                                        toNumberIT(
                                            homeData.find(item => item.label === "Importo Proposto")?.value
                                        )
                                            ? "red"
                                            : "black"
                                    }}
                                    onChange={(e) =>
                                        handleChangeImportoProposto(
                                          "Importo Anno In Corso",
                                          e.target.value
                                        )
                                      }  
                                      onBlur={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                      
                                        const formatted = sanitizeImporto(e.target.value);
                                        handleChangeImportoProposto("Importo Anno In Corso", formatted);
                                      }}
                                />
                        </td>
                        <td key={"001_q3"}
                            style={{ border: "1px solid #ccc", padding: "4px 6px", backgroundColor: "#fff"}}>
                            {/*}
                            <input type="text" //value={editorAnnoPrecedente.replace(".", ",")}     
                              value={(() => {
                                const raw = editorAnnoPrecedente;
                            
                                if (raw == null || raw === "") return "";
                            
                                let v = raw;
                            
                                if (typeof v === "string" && v.includes(",")) {
                                  v = v.replaceAll(".", "").replace(",", ".");
                                }
                            
                                const n = Number(v);
                            
                                if (isNaN(n)) return "";
                            
                                return n.toFixed(2).replace(".", ",");
                              })()}
                                inputMode="decimal"                           
                                style={{width: "100%", border: "none",outline: "none", background: "transparent", fontSize: "16px", padding: "2px 0", cursor: "text",                             
                                  color: toNumberIT(editorAnnoInCorso) +
                                        toNumberIT(editorAnnoPrecedente) !==
                                        toNumberIT(homeData.find(item => item.label === "Importo Proposto")?.value)
                                    ? "red"
                                    : "black"  
                                }}
                                
                                onChange={(e) => {                                
                                      handleChangeImportoProposto("Importo Anno Precedente", e.target.value);
                                  }}
                                onFocus={(e) => { 
                                    e.target.parentElement.style.backgroundColor = "#f5f7fa"; 
                                    e.target.parentElement.style.boxShadow = "inset 0 0 0 1px #1976d2";
                                }}
                                onBlur={(e) => { 
                                    e.target.parentElement.style.backgroundColor = "#fff";
                                    e.target.parentElement.style.boxShadow = "none";
                                    handleChangeImportoProposto("Importo Anno Precedente", sanitizeImporto(e.target.value));
                                }}/>
                                */}
                                <input
                                    type="text"
                                    value={editorAnnoPrecedente ?? ""}
                                    inputMode="decimal"
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        background: "transparent",
                                        fontSize: "16px",
                                        padding: "2px 0",
                                        cursor: "text",
                                        color:
                                        toNumberIT(editorAnnoInCorso) +
                                            toNumberIT(editorAnnoPrecedente) !==
                                        toNumberIT(
                                            homeData.find(item => item.label === "Importo Proposto")?.value
                                        )
                                            ? "red"
                                            : "black"
                                    }}
                                    onChange={(e) =>
                                        handleChangeImportoProposto(
                                          "Importo Anno Precedente",
                                          e.target.value
                                        )
                                      }   
                                      onBlur={(e) => {
                                        e.target.parentElement.style.backgroundColor = "#fff";
                                        e.target.parentElement.style.boxShadow = "none";
                                      
                                        const formatted = sanitizeImporto(e.target.value);
                                        handleChangeImportoProposto("Importo Anno Precedente", formatted);
                                      }} />
                        </td>
                                     
                     
              </tr>
                          
          </tbody>
        </table>
          </div>
         
        
          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseImportoProposto} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveImportoProposto} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>

      <Modal
        open={openSlide}
        keepMounted={false} 
        onClose={handleCloseSlide}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div style={{ position: 'absolute', top: '5%', left: '5%', width: '90%', height: '90%',
            backgroundColor: 'white', padding: '20px', overflow: 'auto', boxShadow: 24,
            borderRadius: '8px', display: 'flex',flexDirection: 'column',}} >

            <h2 id="edit-modal-title">Scheda Progetto</h2>
            <div style={{ flex: 1, marginBottom: '16px', position: 'relative' }}>

            {/* SPINNER */}
            {loadingSlide && (
            <div style={{
                position: 'absolute', inset: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: 'rgba(255,255,255,0.85)',
                zIndex: 10,
            }}>
                <CircularProgress />   {/* oppure qualsiasi spinner tu già usi */}
            </div>
            )}

            {/* ERRORE */}
            {!loadingSlide && errorSlide && (
            <div style={{ color: '#c00', fontSize: 14, padding: '20px 0' }}>
                {errorSlide}
            </div>
            )}

            {/* SCHEDA – ref qui, così lo screenshot non cattura titolo e bottoni */}
            {!loadingSlide && !errorSlide && dataSlide && (
            <div ref={schedaRef}>
                <SchedaProgetto data={dataSlide} />
            </div>
            )}
            </div>
           
            <div style={{ paddingTop:"10px", textAlign: 'right' }}>
                <button className="button154" onClick={handleCloseSlide} style={{ marginRight: 10, width:'100px' }}>Chiudi</button>
                <button className="button11" onClick={handleSaveSlide} style={{ marginRight: 10, width:'100px' }}>Stampa</button>
            </div>
        </div>
      </Modal>

     


      {alert}
    </div>   
       
    );

   
 


}
